import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, Input, Output, Inject, NgModule } from '@angular/core';
import * as i4 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i7 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i8 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i1$3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import * as i14 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i10 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i12 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1 from '@angular/forms';
import { UntypedFormBuilder, Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { getNestedProperty, hasValidValue, clonePOJO, getNiceDateTime, getNiceDate, stringToNiceDate, isStringADateFormat, stringToNiceDateTime, getNiceBool } from 'datahive-basic';
import * as i2$3 from '@angular/router';
import * as i1$2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$2 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i15 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from 'datahive-ngx-ui';
import { DatahiveNgxUiModule } from 'datahive-ngx-ui';
import * as i1$1 from 'datahive-ngx-graph';
import { DataHiveNgxGraphModule } from 'datahive-ngx-graph';
import * as i5 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i2$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i13 from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { BaseEntity } from 'datahive-architecture';

var ConditionType;
(function (ConditionType) {
    ConditionType[ConditionType["Equals"] = 0] = "Equals";
    ConditionType[ConditionType["NoEquals"] = 1] = "NoEquals";
    ConditionType[ConditionType["GreaterThan"] = 2] = "GreaterThan";
    ConditionType[ConditionType["SmallerThan"] = 3] = "SmallerThan";
})(ConditionType || (ConditionType = {}));

var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["Text"] = 0] = "Text";
    PropertyType[PropertyType["Number"] = 1] = "Number";
    PropertyType[PropertyType["FloatingNumber"] = 2] = "FloatingNumber";
    PropertyType[PropertyType["YesNo"] = 3] = "YesNo";
    PropertyType[PropertyType["Select"] = 4] = "Select";
    PropertyType[PropertyType["Date"] = 5] = "Date";
    PropertyType[PropertyType["DateTime"] = 6] = "DateTime";
    PropertyType[PropertyType["User"] = 7] = "User";
    PropertyType[PropertyType["Calculated"] = 8] = "Calculated";
})(PropertyType || (PropertyType = {}));

class Multivalue {
}

function getFirstFromMultiValue(multivalue) {
    let value = '';
    const property = getNestedProperty(multivalue, ['0', 'Value']);
    if (hasValidValue(property)) {
        value = property;
    }
    return value;
}
function getSecondaryFromMultiValueIfExistsOtherWiseFirst(multivalue) {
    let value = '';
    const property = getNestedProperty(multivalue, ['1', 'Value']);
    if (hasValidValue(property)) {
        value = property;
    }
    if (value) {
        return value;
    }
    else {
        return getFirstFromMultiValue(multivalue);
    }
}
function getMultiValueForm(validators = null) {
    const formBuilder = new UntypedFormBuilder();
    let x;
    if (validators && validators.length > 0) {
        x = {
            Value: ['', [validators]],
            Date: [null]
        };
    }
    else {
        x = {
            Value: [''],
            Date: [null]
        };
    }
    return formBuilder.array([formBuilder.group(x)]);
}
function getMultivalueAsString(mv) {
    let res = '';
    if (!mv) {
        return res;
    }
    for (let m of mv) {
        res = m.Value + ' ';
    }
    return res;
}
function isMultivalueCheckboxEnabled(control) {
    if (control) {
        if (control.value) {
            const multivalue = control.value;
            if (control.value.length > 0) {
                if (control.value[0].Value === true) {
                    return true;
                }
            }
        }
    }
    return false;
}
function multivalueFactory(value) {
    const multivalue = new Multivalue();
    multivalue.Value = value;
    const list = [];
    list.push(multivalue);
    return list;
}
function multivalueDoubleFactory(value1, value2) {
    const multivalue1 = new Multivalue();
    multivalue1.Value = value1;
    const multivalue2 = new Multivalue();
    multivalue2.Value = value2;
    const list = [];
    list.push(multivalue1);
    list.push(multivalue2);
    return list;
}

class PropertyEntity {
}
function copyProperty(property) {
    let p = new PropertyEntity();
    p.Id = property.Id;
    p.Name = property.Name;
    p.Type = property.Type;
    p.Control = property.Control;
    p.Description = property.Description;
    p.ErrorMessage = property.ErrorMessage;
    p.Regex = property.Regex;
    p.IncludeInQuickSearch = property.IncludeInQuickSearch;
    p.Unit = property.Id;
    p.DefaultValue = property.Id;
    p.ShowConditions = property.ShowConditions;
    p.ConditionExpression = property.Id;
    p.MinLength = property.MinLength;
    p.MaxLength = property.MaxLength;
    p.MinValue = property.MinValue;
    p.MaxValue = property.MaxValue;
    p.Options = property.Options;
    p.RequireValue = property.RequireValue;
    p.MultipleValues = property.MultipleValues;
    p.UniqueValue = property.UniqueValue;
    p.ImageFileName = property.Id;
    return clonePOJO(p);
}

var ControlType;
(function (ControlType) {
    ControlType[ControlType["TextField"] = 0] = "TextField";
    ControlType[ControlType["TextArea"] = 1] = "TextArea";
    ControlType[ControlType["Slider"] = 2] = "Slider";
    ControlType[ControlType["Dropdown"] = 3] = "Dropdown";
    ControlType[ControlType["Checkbox"] = 4] = "Checkbox";
    ControlType[ControlType["ToggleSlider"] = 5] = "ToggleSlider";
    ControlType[ControlType["RadioButton"] = 6] = "RadioButton";
    ControlType[ControlType["DatePicker"] = 7] = "DatePicker";
    ControlType[ControlType["DateTimePicker"] = 8] = "DateTimePicker";
    ControlType[ControlType["PeoplePicker"] = 9] = "PeoplePicker";
})(ControlType || (ControlType = {}));

var InputType;
(function (InputType) {
    InputType[InputType["Checkbox"] = 0] = "Checkbox";
    InputType[InputType["Textbox"] = 1] = "Textbox";
    InputType[InputType["DropdownMenu"] = 2] = "DropdownMenu";
    InputType[InputType["Datepicker"] = 3] = "Datepicker";
    InputType[InputType["RadioButton"] = 4] = "RadioButton";
})(InputType || (InputType = {}));

var InputDataType;
(function (InputDataType) {
    InputDataType[InputDataType["StringValue"] = 0] = "StringValue";
    InputDataType[InputDataType["IntegerValue"] = 1] = "IntegerValue";
    InputDataType[InputDataType["FloatValue"] = 2] = "FloatValue";
    InputDataType[InputDataType["DateValue"] = 3] = "DateValue";
    InputDataType[InputDataType["BoolValue"] = 4] = "BoolValue";
})(InputDataType || (InputDataType = {}));

function getOptionWithoutVariables(option) {
    if (option) {
        var pattern = /\{(.*?)\}/g;
        try {
            option = option.replace(pattern, '');
        }
        catch (e) {
            /** If a number is provided or a date or so */
            return option + '';
        }
        return option;
    }
    else {
        return '';
    }
}

class ValidationFunctions {
    constructor() {
        this.numericRegex = '^[0-9]*$';
        this.alphanumericRegex = '^[a-zA-Z0-9]*$';
        this.alphanumericCapitalRegex = '^[A-Z0-9]*$';
        this.alphaCapitalRegex = '^[A-Z]*$';
        this.specialCharactersRegex = '^[a-zA-Z0-9./()\-?&]*$';
        this.zeroToFourRegex = '^[0-4]$';
        this.maxDate = new Date(2010, 1, 1);
    }
    hasNoValidValueOrEmptyString(value) {
        if (!hasValidValue(value) || value === '') {
            return true;
        }
        else {
            return false;
        }
    }
    range(min = Number.MIN_VALUE, max = Number.MAX_VALUE, allowFloat = false) {
        return (control) => {
            if (this.hasNoValidValueOrEmptyString(control.value)) {
                return null;
            }
            if (this.isNumberInRange(control.value, min, max, allowFloat)) {
                return null;
            }
            else {
                return { range: false };
            }
        };
    }
    minMaxLength(minLength = 0, maxLength = 1000) {
        return (control) => {
            if (this.hasNoValidValueOrEmptyString(control.value)) {
                return null;
            }
            const pattern = '^.{' + minLength + ',' + maxLength + '}$';
            const regex = RegExp(pattern);
            const value = control.value;
            if (!regex.test(value)) {
                return { regex: false };
            }
            else {
                return null;
            }
        };
    }
    isNumber(allowFloat) {
        return (control) => {
            if (this.hasNoValidValueOrEmptyString(control.value)) {
                return null;
            }
            const value = control.value;
            if (isNaN(value)) {
                return { number: false };
            }
            else {
                if (allowFloat === false && (typeof value.includes === 'function' && value.includes('.'))) {
                    return { number: false };
                }
                return null;
            }
        };
    }
    multivalueNumber(allowFloat) {
        return (control) => {
            const multivalueList = control.value;
            if (multivalueList) {
                let isNumber = true;
                multivalueList.forEach(multivalue => {
                    const value = multivalue.Value;
                    if (!value)
                        return true;
                    if (isNaN(value)) {
                        isNumber = false;
                    }
                    else {
                        if (allowFloat === false && typeof value.includes === 'function' && multivalue.Value.includes('.')) {
                            isNumber = false;
                        }
                    }
                    return false;
                });
                if (isNumber === true) {
                    return null;
                }
                else {
                    return { regex: false };
                }
            }
            return null;
        };
    }
    multivaluePattern(pattern) {
        return (control) => {
            const multivalueList = control.value;
            if (multivalueList) {
                let isRegexTrue = true;
                const regex = RegExp(pattern);
                multivalueList.forEach(multivalue => {
                    if (!regex.test(multivalue.Value)) {
                        isRegexTrue = false;
                    }
                });
                if (isRegexTrue === true) {
                    return null;
                }
                else {
                    return { regex: false };
                }
            }
            return null;
        };
    }
    multivalueLength(minLength, maxLength) {
        return (control) => {
            const pattern = '^.{' + minLength + ',' + maxLength + '}$';
            const multivalueList = control.value;
            if (multivalueList) {
                let isRegexTrue = true;
                const regex = RegExp(pattern);
                multivalueList.forEach(multivalue => {
                    if (!regex.test(multivalue.Value)) {
                        isRegexTrue = false;
                    }
                });
                if (isRegexTrue === true) {
                    return null;
                }
                else {
                    return { regex: false };
                }
            }
            return null;
        };
    }
    multivalueRange(min = Number.MIN_VALUE, max = Number.MAX_VALUE, allowFloat = false) {
        return (control) => {
            const multivalueList = control.value;
            if (multivalueList) {
                let isInRange = true;
                multivalueList.forEach(multivalue => {
                    if (!this.isNumberInRange(multivalue.Value, min, max, allowFloat)) {
                        isInRange = false;
                    }
                });
                if (isInRange === true) {
                    return null;
                }
                else {
                    return { range: false };
                }
            }
            return null;
        };
    }
    isNumberInRange(value, min, max, allowFloat = false) {
        if (!hasValidValue(value)) {
            return false;
        }
        let regexNumbers = RegExp(/^\d+$/);
        if (allowFloat === true) {
            regexNumbers = RegExp(/^[+-]?\d+(\.\d+)?$/);
        }
        if (regexNumbers.test(value) === true) {
            const num = parseFloat(value);
            return num >= min && num <= max ? true : false;
        }
        else {
            return false;
        }
    }
}

class PropertyControlComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.focused = new EventEmitter();
        this.PropertyType = PropertyType;
        this.showDescription = false;
        this.ControlType = ControlType;
        this.propagateChange = (value) => { };
        this.onValidationChange = () => { };
        this.validations = new ValidationFunctions();
        this.hasValidValue = hasValidValue;
    }
    ngOnInit() {
        this.determineValidators();
        this.determineExpectedType();
        if (this.property.Type === PropertyType.Select &&
            this.optionsProvided() === true) {
            for (let option in this.property.Options) {
                this.property.Options[option].Value = getOptionWithoutVariables(this.property.Options[option].Value);
            }
        }
    }
    isTrue() {
        return this.formControl.valid === true;
    }
    optionsProvided() {
        if (!this.property.Options ||
            Array.isArray(this.property.Options) === false ||
            this.property.Options.length === 0) {
            return false;
        }
        else {
            return true;
        }
    }
    generateDummySN() {
        this.formControl.patchValue(this.generateRandomSerialNumber());
    }
    focusedEvent() {
        this.focused.emit(this.property);
    }
    reset() {
        this.formControl.reset();
        this.propagateChange(null);
    }
    determineExpectedType() {
        if (this.property.Type === PropertyType.Date ||
            this.property.Type === PropertyType.DateTime) {
            this.inputDataType = InputDataType.DateValue;
        }
        else if (this.property.Type === PropertyType.FloatingNumber) {
            this.inputDataType = InputDataType.FloatValue;
        }
        else if (this.property.Type === PropertyType.Number ||
            this.property.Type === PropertyType.Select) {
            this.inputDataType = InputDataType.IntegerValue;
        }
        else if (this.property.Type === PropertyType.Text ||
            this.property.Type === PropertyType.User) {
            this.inputDataType = InputDataType.StringValue;
        }
        else if (this.property.Type === PropertyType.YesNo) {
            this.inputDataType = InputDataType.BoolValue;
        }
    }
    generateRandomSerialNumber() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let randomSerial = 'D_';
        for (let i = 0; i < 5; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomSerial += characters.charAt(randomIndex);
        }
        randomSerial += '_DUMMY';
        return randomSerial;
    }
    determineValidators() {
        let minMaxLengthValidator = Validators.nullValidator;
        let minMaxValidator = Validators.nullValidator;
        let regexValidator = Validators.nullValidator;
        let requiredValidator = Validators.nullValidator;
        let isNumberValidator = Validators.nullValidator;
        if (this.property.MinLength || this.property.MaxLength) {
            minMaxLengthValidator = this.validations.minMaxLength(this.property.MinLength, this.property.MaxLength);
        }
        if (this.property.MinValue || this.property.MaxValue) {
            minMaxValidator = this.validations.range(this.property.MinValue, this.property.MaxValue, this.property.Type === PropertyType.FloatingNumber);
        }
        if (this.property.Regex) {
            regexValidator = Validators.pattern(this.property.Regex);
        }
        if (this.property.RequireValue === true) {
            requiredValidator = Validators.required;
        }
        if (this.property.Type === PropertyType.Number) {
            isNumberValidator = this.validations.isNumber(false);
        }
        if (this.property.Type === PropertyType.FloatingNumber) {
            isNumberValidator = this.validations.isNumber(true);
        }
        this.formControl = this.formBuilder.control([''], [requiredValidator,
            minMaxValidator,
            minMaxLengthValidator,
            regexValidator,
            isNumberValidator]);
        this.formControl.valueChanges.subscribe(_ => {
            let value = this.formControl.value;
            if (!hasValidValue(value)) {
                this.propagateChange(null);
            }
            if (this.inputDataType === InputDataType.StringValue) {
                value = value + '';
            }
            else if (this.inputDataType === InputDataType.FloatValue) {
                if (!isNaN(value)) {
                    value = parseFloat(value);
                }
            }
            else if (this.inputDataType === InputDataType.IntegerValue) {
                if (!isNaN(value)) {
                    if ((typeof value.includes !== 'function') || !value.includes('.')) {
                        value = parseInt(value);
                    }
                }
            }
            else if (this.inputDataType === InputDataType.BoolValue) {
                value = (value);
            }
            else if (this.inputDataType === InputDataType.DateValue) {
                /** No action required */
            }
            this.propagateChange(value);
        });
        /* TODO: This control is usually embedded to other controls. After a timeout I propagate the change, to tell higher controls that the control is not valid.
           I know this is bad coding... there must be a better solution, but currently I have no idea why this is necessary. If I do not put this line, invalid components will
           not be recognized as invalid.. **/
        setTimeout(_ => {
            this.propagateChange(this.formControl.value);
        }, 0);
    }
    toggle(checkbox, event) {
        event.preventDefault();
        if (checkbox.checked === false && checkbox.indeterminate === true) {
            checkbox.checked = false;
            checkbox.indeterminate = false;
            this.formControl.patchValue(false);
        }
        else if (checkbox.checked === true && checkbox.indeterminate === false) {
            checkbox.checked = false;
            checkbox.indeterminate = true;
            this.formControl.patchValue(null);
        }
        else if (checkbox.checked === false && checkbox.indeterminate === false) {
            checkbox.checked = true;
            checkbox.indeterminate = false;
            this.formControl.patchValue(true);
        }
        this.propagateChange(this.formControl.value);
    }
    writeValue(value) {
        /** A slider control will be false by default - not null. In contrary to checkboxes that have their indeterminate state. */
        const defaultValue = this.property.DefaultValue;
        if (this.property.Control === ControlType.ToggleSlider && !hasValidValue(value)) {
            this.formControl.setValue(false);
        }
        else {
            if (hasValidValue(value) && value !== '') {
                this.formControl.setValue(value);
            }
            else {
                if (hasValidValue(defaultValue)) {
                    this.formControl.setValue(defaultValue);
                }
                else {
                    this.formControl.setValue(null);
                }
            }
        }
    }
    validate() {
        if (this.formControl.valid) {
            return null;
        }
        else {
            return { invalid: this.property.ErrorMessage };
        }
    }
    _applyFormState() { }
    ;
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
    registerOnDisabledChange() { }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
}
PropertyControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: PropertyControlComponent, deps: [{ token: i1.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component });
PropertyControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: PropertyControlComponent, selector: "app-product-form-property", inputs: { property: "property", baseCdn: "baseCdn" }, outputs: { focused: "focused" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PropertyControlComponent),
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PropertyControlComponent),
            multi: true
        }], ngImport: i0, template: "\r\n<div (mouseover)=\"showDescription = true\"\r\n      class=\"property-control-outer\"\r\n     (mouseleave)=\"showDescription = false\">\r\n   <div *ngIf=\"property.Control === ControlType.TextField\">            \r\n      <div style=\"display: flex;\"\r\n           class=\"bs-default-control\">\r\n         <div style=\"flex-basis: 0; flex-grow: 1;\">\r\n            <app-bs-textfield [placeholder]=\"property.Name\"\r\n                              [invalid]=\"!formControl.valid\"\r\n                              [formControl]=\"formControl\">\r\n            </app-bs-textfield>   \r\n            <button (click)=\"generateDummySN()\"\r\n                    mat-button\r\n                    type=\"button\"\r\n                    *ngIf=\"property.Id === 'SerialNumber'\">\r\n               Generate S/N\r\n            </button>             \r\n         </div>\r\n         <div style=\"flex-basis: 30px; flex-grow: 0; margin-top: 21px; margin-left: 5px;\">\r\n            {{property.Unit}}\r\n         </div>\r\n      </div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.TextArea\"> \r\n      <span>{{property.Name}}</span>\r\n      <textarea [formControl]=\"formControl\"\r\n                placeholder=\"-\"\r\n                class=\"bs-default-control bs-textarea\"></textarea>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Slider\">  \r\n      <span>{{property.Name}}</span> \r\n      <mat-slider [min]=\"property.MinValue\"\r\n                  [max]=\"property.MaxValue\"\r\n                  class=\"bs-default-control\"  \r\n                  color=\"primary\"\r\n                  [formControl]=\"formControl\"      \r\n                  [step]=\"1\">\r\n      </mat-slider>\r\n      <strong>{{formControl.value}}</strong>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Checkbox\">  \r\n      <mat-checkbox [formControl]=\"formControl\"\r\n                    #forme    \r\n                    color=\"primary\"     \r\n                    [indeterminate]=\"!hasValidValue(formControl.value) ? true : false\"\r\n                    (click)=\"toggle(forme, $event)\" \r\n                    class=\"bs-default-control\">\r\n         {{property.Name}}\r\n      </mat-checkbox>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.ToggleSlider\">      \r\n      <mat-slide-toggle [formControl]=\"formControl\"\r\n                        color=\"primary\"\r\n                        class=\"bs-default-control\">\r\n         {{property.Name}}\r\n      </mat-slide-toggle>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Dropdown && optionsProvided() === true\">     \r\n      <mat-form-field class=\"bs-default-control float-left\">\r\n         <mat-label>{{property.Name}}</mat-label>\r\n         <mat-select [formControl]=\"formControl\"\r\n                     color=\"primary\">\r\n            <ng-container *ngFor=\"let option of property.Options\" >\r\n               <mat-option [value]=\"option.Index\">\r\n                  {{option.Value}}\r\n               </mat-option>\r\n            </ng-container>\r\n         </mat-select>\r\n         <div *ngIf=\"optionsProvided() === false\">\r\n            No options defined. Please specify some.\r\n         </div>\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>  \r\n      <div class=\"clear-both\"></div>     \r\n   </div>   \r\n   <div *ngIf=\"property.Control === ControlType.RadioButton && property.Options && property.Options.length > 0\">     \r\n      <label class=\"bs-radio-label float-left\" \r\n             style=\"margin-bottom: 10px;\">\r\n         {{property.Name}}\r\n      </label>\r\n      <div class=\"float-left\">\r\n         <mat-radio-group [formControl]=\"formControl\"\r\n                          class=\"bs-default-control\"\r\n                          color=\"primary\">\r\n            <mat-radio-button *ngFor=\"let option of property.Options\" \r\n                              [value]=\"option.Index\">\r\n               {{option.Value}}\r\n            </mat-radio-button>\r\n            <div *ngIf=\"!property.Options || property.Options.length === 0\">\r\n               No options defined. Please specify some.\r\n            </div>         \r\n         </mat-radio-group>        \r\n      </div>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div> \r\n      <div class=\"clear-both\"></div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.DatePicker\">\r\n      <mat-form-field class=\"bs-default-control\">\r\n         <mat-label>{{property.Name}}</mat-label>\r\n         <input matInput \r\n                [matDatepicker]=\"picker\"\r\n                placeholder=\"-\"\r\n                [formControl]=\"formControl\">\r\n         <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n         <mat-datepicker #picker></mat-datepicker>\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>        \r\n      <div class=\"clear-both\"></div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.DateTimePicker\"> \r\n      <mat-form-field>\r\n         <input matInput \r\n                type=\"datetime-local\"\r\n                placeholder=\"-\"\r\n                [formControl]=\"formControl\"\r\n                [placeholder]=\"property.Name\">\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>    \r\n      <div class=\"clear-both\"></div>    \r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.PeoplePicker\"> \r\n      <app-aad-object-select [formControl]=\"formControl\"\r\n                             [placeholder]=\"property.Name\">\r\n      </app-aad-object-select>     \r\n   </div>   \r\n   <div class=\"bs-property-error-message-outer\"\r\n        *ngIf=\"formControl.valid === false\">\r\n      <span class=\"bs-property-error-message\"\r\n            [class.show-description]=\"formControl.valid === false\"\r\n            [class.hide-description]=\"isTrue()\">\r\n         {{property.ErrorMessage}}\r\n      </span>\r\n   </div>\r\n   <div class=\"bs-property-info-icon bs-icon-small bs-icon-info-circle\"\r\n        *ngIf=\"property.Description\"\r\n        (click)=\"focusedEvent()\">\r\n   </div>  \r\n</div>\r\n<div *ngIf=\"property.ImageFileName\">\r\n   <img [src]=\"baseCdn + property.ImageFileName\"\r\n        class=\"bs-property-form-image\">\r\n</div>\r\n", styles: ["app-multivalue{display:block}app-bs-textfield{display:block}.bs-radio-label{font-weight:700;margin-right:10px}.bs-property-form-image{max-width:200px}.bs-default-control{width:100%;min-width:100px}.property-control-outer{position:relative}.property-control-outer:hover .bs-property-info-icon{display:block}.property-control-outer .bs-property-info-icon{position:absolute;display:none;top:-5px;right:0;cursor:pointer}.property-control-outer .bs-property-info-icon:hover{color:#d17600}\n"], dependencies: [{ kind: "component", type: i2.BSTextfieldComponent, selector: "app-bs-textfield", inputs: ["iconClass", "invalid", "inputType", "placeholder", "errorStateMatcher", "showPlaceholder"], outputs: ["valueChanged"] }, { kind: "component", type: i1$1.AADObjectSelectComponent, selector: "app-aad-object-select", inputs: ["placeholder", "iconClass", "required", "multiple"], outputs: ["valueChanged"] }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i5.MatLabel, selector: "mat-label" }, { kind: "directive", type: i5.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i7.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "component", type: i8.MatSlider, selector: "mat-slider", inputs: ["disabled", "color", "tabIndex", "invert", "max", "min", "step", "thumbLabel", "tickInterval", "value", "displayWith", "valueText", "vertical"], outputs: ["change", "input", "valueChange"], exportAs: ["matSlider"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i10.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i10.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i12.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i12.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i12.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i13.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i14.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i15.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: PropertyControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-product-form-property', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => PropertyControlComponent),
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => PropertyControlComponent),
                            multi: true
                        }], template: "\r\n<div (mouseover)=\"showDescription = true\"\r\n      class=\"property-control-outer\"\r\n     (mouseleave)=\"showDescription = false\">\r\n   <div *ngIf=\"property.Control === ControlType.TextField\">            \r\n      <div style=\"display: flex;\"\r\n           class=\"bs-default-control\">\r\n         <div style=\"flex-basis: 0; flex-grow: 1;\">\r\n            <app-bs-textfield [placeholder]=\"property.Name\"\r\n                              [invalid]=\"!formControl.valid\"\r\n                              [formControl]=\"formControl\">\r\n            </app-bs-textfield>   \r\n            <button (click)=\"generateDummySN()\"\r\n                    mat-button\r\n                    type=\"button\"\r\n                    *ngIf=\"property.Id === 'SerialNumber'\">\r\n               Generate S/N\r\n            </button>             \r\n         </div>\r\n         <div style=\"flex-basis: 30px; flex-grow: 0; margin-top: 21px; margin-left: 5px;\">\r\n            {{property.Unit}}\r\n         </div>\r\n      </div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.TextArea\"> \r\n      <span>{{property.Name}}</span>\r\n      <textarea [formControl]=\"formControl\"\r\n                placeholder=\"-\"\r\n                class=\"bs-default-control bs-textarea\"></textarea>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Slider\">  \r\n      <span>{{property.Name}}</span> \r\n      <mat-slider [min]=\"property.MinValue\"\r\n                  [max]=\"property.MaxValue\"\r\n                  class=\"bs-default-control\"  \r\n                  color=\"primary\"\r\n                  [formControl]=\"formControl\"      \r\n                  [step]=\"1\">\r\n      </mat-slider>\r\n      <strong>{{formControl.value}}</strong>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Checkbox\">  \r\n      <mat-checkbox [formControl]=\"formControl\"\r\n                    #forme    \r\n                    color=\"primary\"     \r\n                    [indeterminate]=\"!hasValidValue(formControl.value) ? true : false\"\r\n                    (click)=\"toggle(forme, $event)\" \r\n                    class=\"bs-default-control\">\r\n         {{property.Name}}\r\n      </mat-checkbox>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.ToggleSlider\">      \r\n      <mat-slide-toggle [formControl]=\"formControl\"\r\n                        color=\"primary\"\r\n                        class=\"bs-default-control\">\r\n         {{property.Name}}\r\n      </mat-slide-toggle>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.Dropdown && optionsProvided() === true\">     \r\n      <mat-form-field class=\"bs-default-control float-left\">\r\n         <mat-label>{{property.Name}}</mat-label>\r\n         <mat-select [formControl]=\"formControl\"\r\n                     color=\"primary\">\r\n            <ng-container *ngFor=\"let option of property.Options\" >\r\n               <mat-option [value]=\"option.Index\">\r\n                  {{option.Value}}\r\n               </mat-option>\r\n            </ng-container>\r\n         </mat-select>\r\n         <div *ngIf=\"optionsProvided() === false\">\r\n            No options defined. Please specify some.\r\n         </div>\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>  \r\n      <div class=\"clear-both\"></div>     \r\n   </div>   \r\n   <div *ngIf=\"property.Control === ControlType.RadioButton && property.Options && property.Options.length > 0\">     \r\n      <label class=\"bs-radio-label float-left\" \r\n             style=\"margin-bottom: 10px;\">\r\n         {{property.Name}}\r\n      </label>\r\n      <div class=\"float-left\">\r\n         <mat-radio-group [formControl]=\"formControl\"\r\n                          class=\"bs-default-control\"\r\n                          color=\"primary\">\r\n            <mat-radio-button *ngFor=\"let option of property.Options\" \r\n                              [value]=\"option.Index\">\r\n               {{option.Value}}\r\n            </mat-radio-button>\r\n            <div *ngIf=\"!property.Options || property.Options.length === 0\">\r\n               No options defined. Please specify some.\r\n            </div>         \r\n         </mat-radio-group>        \r\n      </div>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div> \r\n      <div class=\"clear-both\"></div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.DatePicker\">\r\n      <mat-form-field class=\"bs-default-control\">\r\n         <mat-label>{{property.Name}}</mat-label>\r\n         <input matInput \r\n                [matDatepicker]=\"picker\"\r\n                placeholder=\"-\"\r\n                [formControl]=\"formControl\">\r\n         <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\r\n         <mat-datepicker #picker></mat-datepicker>\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>        \r\n      <div class=\"clear-both\"></div>\r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.DateTimePicker\"> \r\n      <mat-form-field>\r\n         <input matInput \r\n                type=\"datetime-local\"\r\n                placeholder=\"-\"\r\n                [formControl]=\"formControl\"\r\n                [placeholder]=\"property.Name\">\r\n      </mat-form-field>\r\n      <div class=\"float-left bs-icon-small bs-icon-minus-circle\"\r\n           *ngIf=\"hasValidValue(formControl.value)\"\r\n           (click)=\"reset()\"\r\n           [matTooltip]=\"'Reset ' + property.Name\">\r\n      </div>    \r\n      <div class=\"clear-both\"></div>    \r\n   </div>\r\n   <div *ngIf=\"property.Control === ControlType.PeoplePicker\"> \r\n      <app-aad-object-select [formControl]=\"formControl\"\r\n                             [placeholder]=\"property.Name\">\r\n      </app-aad-object-select>     \r\n   </div>   \r\n   <div class=\"bs-property-error-message-outer\"\r\n        *ngIf=\"formControl.valid === false\">\r\n      <span class=\"bs-property-error-message\"\r\n            [class.show-description]=\"formControl.valid === false\"\r\n            [class.hide-description]=\"isTrue()\">\r\n         {{property.ErrorMessage}}\r\n      </span>\r\n   </div>\r\n   <div class=\"bs-property-info-icon bs-icon-small bs-icon-info-circle\"\r\n        *ngIf=\"property.Description\"\r\n        (click)=\"focusedEvent()\">\r\n   </div>  \r\n</div>\r\n<div *ngIf=\"property.ImageFileName\">\r\n   <img [src]=\"baseCdn + property.ImageFileName\"\r\n        class=\"bs-property-form-image\">\r\n</div>\r\n", styles: ["app-multivalue{display:block}app-bs-textfield{display:block}.bs-radio-label{font-weight:700;margin-right:10px}.bs-property-form-image{max-width:200px}.bs-default-control{width:100%;min-width:100px}.property-control-outer{position:relative}.property-control-outer:hover .bs-property-info-icon{display:block}.property-control-outer .bs-property-info-icon{position:absolute;display:none;top:-5px;right:0;cursor:pointer}.property-control-outer .bs-property-info-icon:hover{color:#d17600}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.UntypedFormBuilder }]; }, propDecorators: { property: [{
                type: Input
            }], focused: [{
                type: Output
            }], baseCdn: [{
                type: Input
            }] } });

class MultivalueDialogComponent {
    constructor(dialogRef, dialogData, formBuilder, changeRef) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.formBuilder = formBuilder;
        this.changeRef = changeRef;
        this.baseCdn = '';
        this.inputType = InputType;
        this.multivalueArray = this.dialogData.historyArray;
        this.property = dialogData.property;
    }
    ngOnInit() {
    }
    getValue(field) {
        return field.controls.Value;
    }
    addPair() {
        const multivalueGroup = this.formBuilder.group({
            Value: ['', [Validators.required]]
        });
        this.multivalueArray.insert(0, multivalueGroup);
        let tmp = this.multivalueArray.value;
        /** TODO: Somehow after renewing the template, my value gets lost. This is strange and works with this fix.
         *  I should later find a better solution. */
        setTimeout(_ => {
            this.multivalueArray.patchValue(tmp);
        }, 100);
    }
    removePair() {
        this.multivalueArray.removeAt(0);
    }
    ok() {
        this.dialogRef.close({ Value: this.multivalueArray.controls[0].controls.Value.value }); //** as FormGroup */
    }
    ngOnDestroy() {
    }
}
MultivalueDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDialogComponent, deps: [{ token: i1$3.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i1.UntypedFormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
MultivalueDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: MultivalueDialogComponent, selector: "app-multivalue-dialog", inputs: { baseCdn: "baseCdn" }, ngImport: i0, template: "<div mat-dialog-title>\r\n    <h3>Enter more values for '{{property.Name}}'</h3>\r\n</div>\r\n<div mat-dialog-content>\r\n      <div *ngFor=\"let field of multivalueArray.controls; let i = index;\">    \r\n         <mat-card> \r\n            <mat-card-content>  \r\n               <div style=\"display: flex;\">\r\n                  <div style=\"flex-grow: 1; flex-basis: 0;\">                                         \r\n                     <app-product-form-property [property]=\"property\"\r\n                                                [baseCdn]=\"baseCdn\"\r\n                                                [formControl]=\"getValue(field)\"> <!-- Todo: Otherwise error?-->\r\n                     </app-product-form-property>\r\n                  </div>       \r\n                  <div *ngIf=\"i===0\" \r\n                        style=\"flex-basis: 100px; flex-grow: 0; margin-top: 10px;\">       \r\n                     <button mat-fab \r\n                             aria-label=\"plus\"\r\n                             color=\"primary\"\r\n                             (click)=\"addPair()\">\r\n                        <div class=\"bs-fab-icon bs-icon-plus\"></div>\r\n                     </button>\r\n                     <button mat-fab\r\n                             *ngIf=\"multivalueArray?.controls.length > 1\"\r\n                             aria-label=\"minus\"\r\n                             (click)=\"removePair()\"\r\n                             style=\"margin-left: 3px;\">\r\n                        <div class=\"bs-fab-icon bs-icon-minus\"></div>\r\n                     </button>                        \r\n                  </div>\r\n               </div>\r\n            </mat-card-content>\r\n        </mat-card>    \r\n        <br />\r\n    </div>    \r\n</div>\r\n<div mat-dialog-actions>\r\n   <button type=\"submit\" \r\n           (click)=\"ok()\" \r\n           mat-raised-button>\r\n         Close\r\n   </button>  \r\n</div>\r\n\r\n", dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$3.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$3.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i4.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "component", type: i15.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: PropertyControlComponent, selector: "app-product-form-property", inputs: ["property", "baseCdn"], outputs: ["focused"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multivalue-dialog', template: "<div mat-dialog-title>\r\n    <h3>Enter more values for '{{property.Name}}'</h3>\r\n</div>\r\n<div mat-dialog-content>\r\n      <div *ngFor=\"let field of multivalueArray.controls; let i = index;\">    \r\n         <mat-card> \r\n            <mat-card-content>  \r\n               <div style=\"display: flex;\">\r\n                  <div style=\"flex-grow: 1; flex-basis: 0;\">                                         \r\n                     <app-product-form-property [property]=\"property\"\r\n                                                [baseCdn]=\"baseCdn\"\r\n                                                [formControl]=\"getValue(field)\"> <!-- Todo: Otherwise error?-->\r\n                     </app-product-form-property>\r\n                  </div>       \r\n                  <div *ngIf=\"i===0\" \r\n                        style=\"flex-basis: 100px; flex-grow: 0; margin-top: 10px;\">       \r\n                     <button mat-fab \r\n                             aria-label=\"plus\"\r\n                             color=\"primary\"\r\n                             (click)=\"addPair()\">\r\n                        <div class=\"bs-fab-icon bs-icon-plus\"></div>\r\n                     </button>\r\n                     <button mat-fab\r\n                             *ngIf=\"multivalueArray?.controls.length > 1\"\r\n                             aria-label=\"minus\"\r\n                             (click)=\"removePair()\"\r\n                             style=\"margin-left: 3px;\">\r\n                        <div class=\"bs-fab-icon bs-icon-minus\"></div>\r\n                     </button>                        \r\n                  </div>\r\n               </div>\r\n            </mat-card-content>\r\n        </mat-card>    \r\n        <br />\r\n    </div>    \r\n</div>\r\n<div mat-dialog-actions>\r\n   <button type=\"submit\" \r\n           (click)=\"ok()\" \r\n           mat-raised-button>\r\n         Close\r\n   </button>  \r\n</div>\r\n\r\n" }]
        }], ctorParameters: function () { return [{ type: i1$3.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { baseCdn: [{
                type: Input
            }] } });

class MultivalueComponent {
    constructor(dialog, fb, changeRef) {
        this.dialog = dialog;
        this.fb = fb;
        this.changeRef = changeRef;
        this.showDate = true;
        this.invalid = false;
        this.baseCdn = '';
        this.valueChanged = new EventEmitter();
        this.focusout = new EventEmitter();
        this.focused = new EventEmitter();
        this.inputType = InputType;
        this.propagateChange = (mv) => { };
    }
    ngOnInit() {
        this.multivalueArray = getMultiValueForm();
        this.addSubscription();
        if (!this.property) {
            this.property = new PropertyEntity();
            this.property.Type = PropertyType.Text;
            this.property.Control = ControlType.TextField;
            this.property.Name = this.displayName;
        }
    }
    focusedEvent(property) {
        this.focused.emit(property);
    }
    getValue(multivalueArray) {
        let array = this.getFirstControl(multivalueArray);
        if (array && array.controls) {
            return array.controls.Value;
        }
    }
    getFirstControl(array) {
        let fg = null;
        if (array) {
            if (array.controls.length > 0) {
                fg = array.controls[0];
            }
        }
        return fg;
    }
    removeDateIfNotSet() {
        if (this.multivalueArray && this.multivalueArray.value) {
            this.multivalueArray.value.forEach(mv => {
                if (!mv.Date) {
                    delete mv.Date;
                }
            });
        }
    }
    addSubscription() {
        this.multivalueArray.valueChanges.subscribe(_ => {
            this.publish();
        });
    }
    writeValue(multivalueList) {
        if (multivalueList) {
            this.multivalueArray = this.fb.array([]);
            this.addSubscription();
            multivalueList.forEach(multivalue => {
                this.multivalueArray.push(this.fb.group({
                    Value: [multivalue.Value]
                }));
            });
        }
    }
    openHistory() {
        const multivalueDialogData = {
            historyArray: this.multivalueArray,
            showDate: this.showDate,
            property: this.property
        };
        const config = new MatDialogConfig();
        config.data = multivalueDialogData;
        const dialogRef = this.dialog.open(MultivalueDialogComponent, config);
        dialogRef.afterClosed().subscribe(result => {
            this.multivalueArray.controls[0].controls.Value.setValue(result.Value); //** As FormGroup */
            this.publish();
            this.focusout.emit();
        });
    }
    resetValue() {
        this.multivalueArray = getMultiValueForm();
        this.publish();
    }
    publish() {
        let isNull = true;
        const multivalueList = [];
        this.multivalueArray.controls.forEach((group) => {
            const multivalue = new Multivalue();
            const value = group.controls.Value.value;
            if (!multivalue.Value) {
                multivalue.Value = value;
            }
            multivalueList.push(multivalue);
        });
        multivalueList.forEach(p => {
            if (p.Value !== null && p.Value !== '' && p.Value !== undefined) {
                isNull = false;
            }
        });
        this.removeDateIfNotSet();
        if (isNull === true) {
            this.propagateChange(undefined);
        }
        else {
            this.propagateChange(multivalueList);
        }
        this.valueChanged.emit();
    }
    validate(formControl) {
        if (this.multivalueArray.valid) {
            return null;
        }
        else {
            return { 'notvalid': true };
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    _applyFormState() { }
    ;
    registerOnDisabledChange() { }
    registerOnTouched() { }
}
MultivalueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueComponent, deps: [{ token: i1$3.MatDialog }, { token: i1.UntypedFormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
MultivalueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: MultivalueComponent, selector: "app-multivalue", inputs: { property: "property", displayName: "displayName", showDate: "showDate", invalid: "invalid", baseCdn: "baseCdn" }, outputs: { valueChanged: "valueChanged", focusout: "focusout", focused: "focused" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultivalueComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MultivalueComponent),
            multi: true
        }
    ], ngImport: i0, template: "<div class=\"multivalue-outer\">\r\n   <i class=\"bs-multivalue-option bs-icon-plus-circle\"\r\n      [style.display]=\"multivalueArray?.controls.length > 1 ? 'block' : 'none'\"\r\n      matTooltip=\"Add more values\"\r\n      (click)=\"openHistory()\">\r\n   </i>\r\n   <i class=\"bs-multivalue-option bs-icon-minus-circle\"\r\n      matTooltip=\"Reset this field\"\r\n      (click)=\"resetValue()\">\r\n   </i>\r\n   <form>\r\n      <app-product-form-property [property]=\"property\"\r\n                                 [baseCdn]=\"baseCdn\"\r\n                                 (focused)=\"focusedEvent($event)\"\r\n                                 [formControl]=\"getValue(multivalueArray)\">\r\n      </app-product-form-property>\r\n   </form>\r\n</div>", styles: [".multivalue-outer{position:relative}.multivalue-outer .bs-icon-plus-circle{display:none;position:absolute;z-index:10;top:33px;cursor:pointer;font-size:15px;left:-o-calc(100% - 45px);left:calc(100% - 45px)}.multivalue-outer .bs-icon-minus-circle{display:none;position:absolute;z-index:10;top:33px;cursor:pointer;color:#a75f00;font-size:15px;left:-o-calc(100% - 60px);left:calc(100% - 60px)}.multivalue-outer:hover .bs-multivalue-option{display:block!important}.multivalue-outer:hover .error-multivalue{margin-top:-13px;font-size:12px}\n"], dependencies: [{ kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: PropertyControlComponent, selector: "app-product-form-property", inputs: ["property", "baseCdn"], outputs: ["focused"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multivalue', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => MultivalueComponent),
                            multi: true,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => MultivalueComponent),
                            multi: true
                        }
                    ], template: "<div class=\"multivalue-outer\">\r\n   <i class=\"bs-multivalue-option bs-icon-plus-circle\"\r\n      [style.display]=\"multivalueArray?.controls.length > 1 ? 'block' : 'none'\"\r\n      matTooltip=\"Add more values\"\r\n      (click)=\"openHistory()\">\r\n   </i>\r\n   <i class=\"bs-multivalue-option bs-icon-minus-circle\"\r\n      matTooltip=\"Reset this field\"\r\n      (click)=\"resetValue()\">\r\n   </i>\r\n   <form>\r\n      <app-product-form-property [property]=\"property\"\r\n                                 [baseCdn]=\"baseCdn\"\r\n                                 (focused)=\"focusedEvent($event)\"\r\n                                 [formControl]=\"getValue(multivalueArray)\">\r\n      </app-product-form-property>\r\n   </form>\r\n</div>", styles: [".multivalue-outer{position:relative}.multivalue-outer .bs-icon-plus-circle{display:none;position:absolute;z-index:10;top:33px;cursor:pointer;font-size:15px;left:-o-calc(100% - 45px);left:calc(100% - 45px)}.multivalue-outer .bs-icon-minus-circle{display:none;position:absolute;z-index:10;top:33px;cursor:pointer;color:#a75f00;font-size:15px;left:-o-calc(100% - 60px);left:calc(100% - 60px)}.multivalue-outer:hover .bs-multivalue-option{display:block!important}.multivalue-outer:hover .error-multivalue{margin-top:-13px;font-size:12px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.MatDialog }, { type: i1.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { property: [{
                type: Input
            }], displayName: [{
                type: Input
            }], showDate: [{
                type: Input
            }], invalid: [{
                type: Input
            }], baseCdn: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }], focusout: [{
                type: Output
            }], focused: [{
                type: Output
            }] } });

class PropertyControlMultiValueComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.baseCdn = '';
        this.focused = new EventEmitter();
        this.propagateChange = (value) => { };
    }
    focusedEvent(property) {
        this.focused.emit(property);
    }
    ngOnInit() {
        this.formControl = this.formBuilder.control(['']);
        this.formControl.valueChanges.subscribe(_ => {
            this.propagateChange(this.formControl.value);
        });
    }
    writeValue(value) {
        this.formControl.setValue(value);
    }
    validate() {
        if (this.formControl.valid) {
            return null;
        }
        else {
            return { invalid: this.property.ErrorMessage };
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
}
PropertyControlMultiValueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: PropertyControlMultiValueComponent, deps: [{ token: i1.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component });
PropertyControlMultiValueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: PropertyControlMultiValueComponent, selector: "app-property-control-multi-value", inputs: { baseCdn: "baseCdn", property: "property" }, outputs: { focused: "focused" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PropertyControlMultiValueComponent),
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PropertyControlMultiValueComponent),
            multi: true
        }], ngImport: i0, template: "<ng-container *ngIf=\"property.MultipleValues === true\">\r\n    <app-multivalue [formControl]=\"formControl\"\r\n                    [showDate]=\"false\"\r\n                    [baseCdn]=\"baseCdn\"\r\n                    (focused)=\"focusedEvent($event)\"\r\n                    [property]=\"property\">\r\n    </app-multivalue>\r\n</ng-container>\r\n<ng-container *ngIf=\"property.MultipleValues === false\">\r\n    <app-product-form-property [property]=\"property\"\r\n                               [baseCdn]=\"baseCdn\"\r\n                               (focused)=\"focusedEvent($event)\"\r\n                               [formControl]=\"formControl\">\r\n    </app-product-form-property>\r\n</ng-container>\r\n\r\n    ", styles: [""], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MultivalueComponent, selector: "app-multivalue", inputs: ["property", "displayName", "showDate", "invalid", "baseCdn"], outputs: ["valueChanged", "focusout", "focused"] }, { kind: "component", type: PropertyControlComponent, selector: "app-product-form-property", inputs: ["property", "baseCdn"], outputs: ["focused"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: PropertyControlMultiValueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-property-control-multi-value', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => PropertyControlMultiValueComponent),
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => PropertyControlMultiValueComponent),
                            multi: true
                        }], template: "<ng-container *ngIf=\"property.MultipleValues === true\">\r\n    <app-multivalue [formControl]=\"formControl\"\r\n                    [showDate]=\"false\"\r\n                    [baseCdn]=\"baseCdn\"\r\n                    (focused)=\"focusedEvent($event)\"\r\n                    [property]=\"property\">\r\n    </app-multivalue>\r\n</ng-container>\r\n<ng-container *ngIf=\"property.MultipleValues === false\">\r\n    <app-product-form-property [property]=\"property\"\r\n                               [baseCdn]=\"baseCdn\"\r\n                               (focused)=\"focusedEvent($event)\"\r\n                               [formControl]=\"formControl\">\r\n    </app-product-form-property>\r\n</ng-container>\r\n\r\n    " }]
        }], ctorParameters: function () { return [{ type: i1.UntypedFormBuilder }]; }, propDecorators: { baseCdn: [{
                type: Input
            }], property: [{
                type: Input
            }], focused: [{
                type: Output
            }] } });

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//        return !!(control && control.invalid);
//    }
// }
class ComponentDefinitionControlsComponent {
    constructor(formBuilder, router) {
        this.formBuilder = formBuilder;
        this.router = router;
        this.hasSerialNumber = true;
        this.isThirdLevel = false; /** Adding a third level class if this segment is shown as a third level GUI container */
        this.baseCdn = '';
        this.ignoreIds = [];
        this.PropertyType = PropertyType;
        this.tmpValue = {};
        //matcher: MyErrorStateMatcher;
        this.missedToUpdateValue = false;
        this.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
        this.propagateChange = _ => { };
        this.onValidationChange = () => { };
        this.initForm();
        //this.matcher = new MyErrorStateMatcher();
    }
    showDescription(property) {
        this.currentPropertyName = property.Name;
        this.currentPropertyDescription = property.Description;
        this.currentPropertyId = property.Id;
    }
    initForm() {
        this.formGroup = this.formBuilder.group({});
        this.formGroup.valueChanges.subscribe(_ => {
            this.propagateChange(this.formGroup.value);
        });
    }
    ngOnInit() { }
    ngOnChanges() {
        this.addComponentDefinitionInstanceToForm();
        if (this.tmpValue && this.missedToUpdateValue === true) {
            this.formGroup.patchValue(this.tmpValue);
        }
    }
    addComponentDefinitionInstanceToForm() {
        if (!this.componentDefinition) {
            return;
        }
        this.componentDefinition.Segments.forEach(segment => {
            segment.Properties.forEach(property => {
                let newControl = null;
                if (property.Type === PropertyType.Text &&
                    property.MultipleValues === false) {
                    newControl = this.formBuilder.control('');
                }
                else {
                    newControl = this.formBuilder.control(null);
                }
                if (property.Id !== 'SerialNumber' || this.hasSerialNumber === true) {
                    this.formGroup.addControl(property.Id, newControl);
                }
            });
        });
    }
    showConditionsMatching(prop) {
        var property = clonePOJO(prop);
        if (!property.ShowConditions || property.ShowConditions.length === 0 || !property.ConditionExpression) {
            return true;
        }
        let allConditionsStateSet = {};
        let count = 0;
        for (const condition of property.ShowConditions) {
            let valueToCheck = this.formGroup.get(condition.PropertyId).value;
            if (property.MultipleValues === true) {
                valueToCheck = getFirstFromMultiValue(valueToCheck);
            }
            if (condition.ConditionType === ConditionType.Equals) {
                if (valueToCheck === condition.Value) {
                    allConditionsStateSet[this.alphabet[count]] = true;
                }
                else {
                    allConditionsStateSet[this.alphabet[count]] = false;
                }
            }
            if (condition.ConditionType === ConditionType.NoEquals) {
                if (valueToCheck !== condition.Value) {
                    allConditionsStateSet[this.alphabet[count]] = true;
                }
                else {
                    allConditionsStateSet[this.alphabet[count]] = false;
                }
            }
            if (condition.ConditionType === ConditionType.GreaterThan) {
                if (valueToCheck > condition.Value) {
                    allConditionsStateSet[this.alphabet[count]] = true;
                }
                else {
                    allConditionsStateSet[this.alphabet[count]] = false;
                }
            }
            if (condition.ConditionType === ConditionType.SmallerThan) {
                if (valueToCheck < condition.Value) {
                    allConditionsStateSet[this.alphabet[count]] = true;
                }
                else {
                    allConditionsStateSet[this.alphabet[count]] = false;
                }
            }
            count++;
        }
        property.ConditionExpression = property.ConditionExpression.replace(/&/g, "&&");
        property.ConditionExpression = property.ConditionExpression.replace('|', '||');
        for (let letter of this.alphabet) {
            if (hasValidValue(allConditionsStateSet[letter])) {
                property.ConditionExpression = property.ConditionExpression.replace(letter, allConditionsStateSet[letter]);
            }
        }
        let valid;
        try {
            valid = eval(property.ConditionExpression);
        }
        catch (e) {
            return true;
        }
        return valid;
    }
    /** Race condition here: Sometimes the value might come earlier then the component definition.
     *  In this case log this and patch the formgroup later.
     *  In all cases where the definition is here, update the form group value here.
     */
    writeValue(value) {
        if (value) {
            if (!this.componentDefinition) {
                this.missedToUpdateValue = true;
                this.tmpValue = value;
            }
            else {
                this.formGroup.patchValue(value);
            }
        }
    }
    navigateToDefinition(id) {
        this.router.navigate(['/product-structure/component-definitions/edit/', id]);
    }
    validate() {
        if (this.formGroup.valid) {
            return null;
        }
        else {
            return { errors: 'not valid' };
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
}
ComponentDefinitionControlsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ComponentDefinitionControlsComponent, deps: [{ token: i1.UntypedFormBuilder }, { token: i2$3.Router }], target: i0.ɵɵFactoryTarget.Component });
ComponentDefinitionControlsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: ComponentDefinitionControlsComponent, selector: "app-component-definition-controls", inputs: { componentDefinition: "componentDefinition", hasSerialNumber: "hasSerialNumber", isThirdLevel: "isThirdLevel", baseCdn: "baseCdn", ignoreIds: "ignoreIds" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ComponentDefinitionControlsComponent),
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ComponentDefinitionControlsComponent),
            multi: true
        }], usesOnChanges: true, ngImport: i0, template: "<div [formGroup]=\"formGroup\"\r\n     class=\"bs-properties-outer\"\r\n     *ngIf=\"componentDefinition\">\r\n   <div class=\"bs-property-controls\">\r\n      <div *ngFor=\"let segment of componentDefinition.Segments\">\r\n         <div [class]=\"isThirdLevel === true ? 'bs-form-segment-third-level' : 'bs-form-segment'\">\r\n            <h4>{{segment.Name}}</h4>            \r\n            <div *ngFor=\"let property of segment.Properties\"\r\n                 [ngClass]=\"{'bs-margin-condition' : property.ConditionExpression }\">   \r\n               <ng-container *ngIf=\"(property.Id !== 'SerialNumber' || hasSerialNumber === true) && property.Type != PropertyType.Calculated && !ignoreIds.includes(property.Id)\">\r\n                  <app-property-control-multi-value [property]=\"property\"      \r\n                                                    [baseCdn]=\"baseCdn\"                                              \r\n                                                    *ngIf=\"showConditionsMatching(property) === true\"\r\n                                                    (focused)=\"showDescription($event)\"\r\n                                                    [formControlName]=\"property.Id\">\r\n                  </app-property-control-multi-value>               \r\n                  <mat-card class=\"bs-property-info\"\r\n                            *ngIf=\"currentPropertyDescription && currentPropertyId === property.Id\">\r\n                     <div class=\"bs-icon-info-circle bs-property-info-icon\"></div>            \r\n                     <div class=\"bs-property-info-name\">\r\n                        {{currentPropertyName}}\r\n                     </div>\r\n                     <textarea disabled \r\n                               class=\"bs-property-info-description\" \r\n                               placeholder=\"-\">{{currentPropertyDescription}}</textarea>        \r\n                  </mat-card>                    \r\n               </ng-container>                            \r\n            </div>\r\n         </div>      \r\n      </div>            \r\n   </div>\r\n</div>\r\n<div class=\"bs-icon-pencil bs-icon-small\"\r\n     (click)=\"navigateToDefinition(componentDefinition.Id)\"\r\n     matTooltip=\"Define fields\">\r\n</div>", styles: [".bs-property-controls{position:relative}.bs-margin-condition{margin-left:20px}.bs-property-info{position:absolute;left:100%;z-index:10;height:500px;width:250px;margin-top:-100px;overflow:hidden}.bs-property-info .bs-property-info-name{font-weight:700}.bs-property-info .bs-property-info-description{margin-top:5px;width:100%;height:100%;background-color:transparent;resize:none;border:none!important;font-family:inherit}.bs-property-info .bs-property-info-icon{color:#00008b}\n"], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: PropertyControlMultiValueComponent, selector: "app-property-control-multi-value", inputs: ["baseCdn", "property"], outputs: ["focused"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ComponentDefinitionControlsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-component-definition-controls', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ComponentDefinitionControlsComponent),
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => ComponentDefinitionControlsComponent),
                            multi: true
                        }], template: "<div [formGroup]=\"formGroup\"\r\n     class=\"bs-properties-outer\"\r\n     *ngIf=\"componentDefinition\">\r\n   <div class=\"bs-property-controls\">\r\n      <div *ngFor=\"let segment of componentDefinition.Segments\">\r\n         <div [class]=\"isThirdLevel === true ? 'bs-form-segment-third-level' : 'bs-form-segment'\">\r\n            <h4>{{segment.Name}}</h4>            \r\n            <div *ngFor=\"let property of segment.Properties\"\r\n                 [ngClass]=\"{'bs-margin-condition' : property.ConditionExpression }\">   \r\n               <ng-container *ngIf=\"(property.Id !== 'SerialNumber' || hasSerialNumber === true) && property.Type != PropertyType.Calculated && !ignoreIds.includes(property.Id)\">\r\n                  <app-property-control-multi-value [property]=\"property\"      \r\n                                                    [baseCdn]=\"baseCdn\"                                              \r\n                                                    *ngIf=\"showConditionsMatching(property) === true\"\r\n                                                    (focused)=\"showDescription($event)\"\r\n                                                    [formControlName]=\"property.Id\">\r\n                  </app-property-control-multi-value>               \r\n                  <mat-card class=\"bs-property-info\"\r\n                            *ngIf=\"currentPropertyDescription && currentPropertyId === property.Id\">\r\n                     <div class=\"bs-icon-info-circle bs-property-info-icon\"></div>            \r\n                     <div class=\"bs-property-info-name\">\r\n                        {{currentPropertyName}}\r\n                     </div>\r\n                     <textarea disabled \r\n                               class=\"bs-property-info-description\" \r\n                               placeholder=\"-\">{{currentPropertyDescription}}</textarea>        \r\n                  </mat-card>                    \r\n               </ng-container>                            \r\n            </div>\r\n         </div>      \r\n      </div>            \r\n   </div>\r\n</div>\r\n<div class=\"bs-icon-pencil bs-icon-small\"\r\n     (click)=\"navigateToDefinition(componentDefinition.Id)\"\r\n     matTooltip=\"Define fields\">\r\n</div>", styles: [".bs-property-controls{position:relative}.bs-margin-condition{margin-left:20px}.bs-property-info{position:absolute;left:100%;z-index:10;height:500px;width:250px;margin-top:-100px;overflow:hidden}.bs-property-info .bs-property-info-name{font-weight:700}.bs-property-info .bs-property-info-description{margin-top:5px;width:100%;height:100%;background-color:transparent;resize:none;border:none!important;font-family:inherit}.bs-property-info .bs-property-info-icon{color:#00008b}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.UntypedFormBuilder }, { type: i2$3.Router }]; }, propDecorators: { componentDefinition: [{
                type: Input
            }], hasSerialNumber: [{
                type: Input
            }], isThirdLevel: [{
                type: Input
            }], baseCdn: [{
                type: Input
            }], ignoreIds: [{
                type: Input
            }] } });

class AgCalcPropertyCellRendererComponent {
    agInit(params) {
        if (params && hasValidValue(params.value)) {
            this.value = params.value;
        }
    }
}
AgCalcPropertyCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgCalcPropertyCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgCalcPropertyCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgCalcPropertyCellRendererComponent, selector: "app-date-ag", ngImport: i0, template: "<ng-container *ngIf=\"value\">\r\n   {{value}}\r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgCalcPropertyCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-date-ag', template: "<ng-container *ngIf=\"value\">\r\n   {{value}}\r\n</ng-container>\r\n" }]
        }] });

// src/app/red-component/red-component.component.ts
class AgCounryFlagsCellRendererComponent {
    constructor() {
        this.countryCode = '';
        this.countryName = '';
    }
    agInit(params) {
        if (params && params.value) {
            /** Country code can be in brackets after the country name - but it can also be the raw value arriving here.
             *  In products i.e. the former is true. For sites the second. */
            var matches = params.value.match(/\((.*?)\)/);
            if (matches) {
                this.countryCode = matches[1];
                this.countryName = params.value;
            }
            else {
                if (params.value) {
                    this.countryCode = params.value;
                    this.countryName = params.data.CountryName;
                }
            }
            if (this.countryCode) {
                this.countryCode = this.countryCode.toLowerCase();
            }
        }
    }
}
AgCounryFlagsCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgCounryFlagsCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgCounryFlagsCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgCounryFlagsCellRendererComponent, selector: "app-country-flags-ag", ngImport: i0, template: "<div style=\"width: 500px;\">\r\n   <div>\r\n      <img [src]=\"'https://flagcdn.com/24x18/' + countryCode + '.png'\"      \r\n         [matTooltip]=\"countryName\"\r\n         onerror=\"this.src='../../../../assets/img/flagerror.png';\"\r\n         *ngIf=\"countryCode\"\r\n         style=\"float: left; margin-top: 5px;\">\r\n   </div>     \r\n   <div style=\"float: left; margin-top: -2px; margin-left: 9px;\">\r\n      {{countryName}}\r\n   </div>\r\n   <div style=\"clear:both\"></div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgCounryFlagsCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-country-flags-ag', template: "<div style=\"width: 500px;\">\r\n   <div>\r\n      <img [src]=\"'https://flagcdn.com/24x18/' + countryCode + '.png'\"      \r\n         [matTooltip]=\"countryName\"\r\n         onerror=\"this.src='../../../../assets/img/flagerror.png';\"\r\n         *ngIf=\"countryCode\"\r\n         style=\"float: left; margin-top: 5px;\">\r\n   </div>     \r\n   <div style=\"float: left; margin-top: -2px; margin-left: 9px;\">\r\n      {{countryName}}\r\n   </div>\r\n   <div style=\"clear:both\"></div>\r\n</div>\r\n" }]
        }] });

class ShowDateTimeComponent {
    constructor() {
        this.showTime = false;
    }
    ngOnInit() {
        this.init();
    }
    ngOnChanges() {
        this.init();
    }
    init() {
        if (this.value && typeof this.value.getMonth !== 'function') {
            this.value = new Date(this.value);
        }
        if (this.showTime) {
            this.formattedDate = getNiceDateTime(this.value);
        }
        else {
            this.formattedDate = getNiceDate(this.value);
        }
    }
}
ShowDateTimeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowDateTimeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShowDateTimeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: ShowDateTimeComponent, selector: "app-show-date-time", inputs: { value: "value", showTime: "showTime" }, usesOnChanges: true, ngImport: i0, template: "{{formattedDate}}", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowDateTimeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-show-date-time', template: "{{formattedDate}}" }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }], showTime: [{
                type: Input
            }] } });

class OptionsComponent {
    constructor() {
        this.color = 'transparent';
        this.fontColor = 'black';
    }
    ngOnInit() {
        if (!this.value) {
            return;
        }
        var pattern = /\{(.*?)\}/g;
        let match = pattern.exec(this.value);
        if (match) {
            this.color = match[1];
            this.fontColor = '#fff';
            if (this.color === 'yellow' ||
                this.color === 'green') {
                this.fontColor = '#000';
            }
        }
        if (this.value.replace) {
            this.showValue = this.value.replace(pattern, '');
        }
        else {
            this.showValue = this.value;
        }
    }
}
OptionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: OptionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OptionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: OptionsComponent, selector: "app-options", inputs: { value: "value" }, ngImport: i0, template: "<span [style.backgroundColor]=\"color\"       \r\n      [style.color]=\"fontColor\"\r\n      class=\"bs-option\">\r\n   {{showValue}}\r\n</span>", styles: [".bs-option{padding:3px;border-radius:2px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: OptionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-options', template: "<span [style.backgroundColor]=\"color\"       \r\n      [style.color]=\"fontColor\"\r\n      class=\"bs-option\">\r\n   {{showValue}}\r\n</span>", styles: [".bs-option{padding:3px;border-radius:2px}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }] } });

class YesNoComponent {
    constructor() {
        this.hasValidValue = hasValidValue;
    }
}
YesNoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: YesNoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
YesNoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: YesNoComponent, selector: "app-yes-no", inputs: { value: "value" }, ngImport: i0, template: "<!-- <span *ngIf=\"value === true\" class=\"bs-icon-checkbox-checked\" style=\"color: green;\"></span>\r\n<span *ngIf=\"!hasValidValue(value)\" class=\"bs-icon-minus-1\" style=\"color: orange;\"></span>\r\n<span *ngIf=\"value === false\" class=\"bs-icon-times\" style=\"color: red;\"></span>\r\n -->\r\n\r\n<div style=\"position: relative;\">\r\n   <div class=\"bs-cover\"></div>\r\n   <mat-checkbox *ngIf=\"value === true\" checked=\"true\" color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>  \r\n   <!-- <mat-checkbox *ngIf=\"!hasValidValue(value)\" indeterminate color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>   -->\r\n   <mat-checkbox *ngIf=\"value === false\" color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>  \r\n</div> \r\n", styles: [".bs-cover{position:absolute;left:0;top:0;background-color:#fff0;width:40px;height:40px;z-index:10}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: YesNoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-yes-no', template: "<!-- <span *ngIf=\"value === true\" class=\"bs-icon-checkbox-checked\" style=\"color: green;\"></span>\r\n<span *ngIf=\"!hasValidValue(value)\" class=\"bs-icon-minus-1\" style=\"color: orange;\"></span>\r\n<span *ngIf=\"value === false\" class=\"bs-icon-times\" style=\"color: red;\"></span>\r\n -->\r\n\r\n<div style=\"position: relative;\">\r\n   <div class=\"bs-cover\"></div>\r\n   <mat-checkbox *ngIf=\"value === true\" checked=\"true\" color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>  \r\n   <!-- <mat-checkbox *ngIf=\"!hasValidValue(value)\" indeterminate color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>   -->\r\n   <mat-checkbox *ngIf=\"value === false\" color=\"primary\" class=\"bs-label-checkbox\"></mat-checkbox>  \r\n</div> \r\n", styles: [".bs-cover{position:absolute;left:0;top:0;background-color:#fff0;width:40px;height:40px;z-index:10}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }] } });

class ShowPropertyComponent {
    constructor() {
        this.PropertyType = PropertyType;
    }
    ngOnInit() {
    }
    copy() {
        copySingleValueToClipboard(this.value);
    }
    getNiceValueForExport(value) {
        return 'declaration in main project';
    }
}
ShowPropertyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowPropertyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShowPropertyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: ShowPropertyComponent, selector: "app-show-property", inputs: { property: "property", value: "value" }, ngImport: i0, template: "<div matTooltip=\"Copy to clipboard\"\r\n     class=\"bs-property-show\"\r\n     (click)=\"copy()\">\r\n   <ng-container *ngIf=\"property.MultipleValues === true\">\r\n      <!-- <app-multivalue-detail [multivalue]=\"true\"\r\n                             [property]=\"property\"\r\n                             [value]=\"value\">\r\n      </app-multivalue-detail>                                                     -->\r\n   </ng-container>\r\n   <ng-container *ngIf=\"property.MultipleValues === false\">\r\n      <ng-container *ngIf=\"property.Type === PropertyType.YesNo\">\r\n         <app-yes-no [value]=\"value\"></app-yes-no>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Text || \r\n                           property.Type === PropertyType.Number || \r\n                           property.Type === PropertyType.FloatingNumber\">\r\n         {{value}}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"property.Type === PropertyType.Select\">\r\n      <app-options [value]=\"value\"></app-options>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.DateTime\">\r\n         <app-show-date-time [value]=\"value\" [showTime]=\"true\"></app-show-date-time>\r\n      </ng-container>         \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Date\">\r\n         <app-show-date-time [value]=\"value\" [showTime]=\"false\"></app-show-date-time>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Calculated\">\r\n         {{value}}\r\n      </ng-container>      \r\n   </ng-container>\r\n</div>\r\n", styles: [".bs-property-show{cursor:pointer}.bs-property-show:hover{color:#4548dd}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: ShowDateTimeComponent, selector: "app-show-date-time", inputs: ["value", "showTime"] }, { kind: "component", type: OptionsComponent, selector: "app-options", inputs: ["value"] }, { kind: "component", type: YesNoComponent, selector: "app-yes-no", inputs: ["value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowPropertyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-show-property', template: "<div matTooltip=\"Copy to clipboard\"\r\n     class=\"bs-property-show\"\r\n     (click)=\"copy()\">\r\n   <ng-container *ngIf=\"property.MultipleValues === true\">\r\n      <!-- <app-multivalue-detail [multivalue]=\"true\"\r\n                             [property]=\"property\"\r\n                             [value]=\"value\">\r\n      </app-multivalue-detail>                                                     -->\r\n   </ng-container>\r\n   <ng-container *ngIf=\"property.MultipleValues === false\">\r\n      <ng-container *ngIf=\"property.Type === PropertyType.YesNo\">\r\n         <app-yes-no [value]=\"value\"></app-yes-no>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Text || \r\n                           property.Type === PropertyType.Number || \r\n                           property.Type === PropertyType.FloatingNumber\">\r\n         {{value}}\r\n      </ng-container>\r\n      <ng-container *ngIf=\"property.Type === PropertyType.Select\">\r\n      <app-options [value]=\"value\"></app-options>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.DateTime\">\r\n         <app-show-date-time [value]=\"value\" [showTime]=\"true\"></app-show-date-time>\r\n      </ng-container>         \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Date\">\r\n         <app-show-date-time [value]=\"value\" [showTime]=\"false\"></app-show-date-time>\r\n      </ng-container>   \r\n      <ng-container *ngIf=\"property.Type === PropertyType.Calculated\">\r\n         {{value}}\r\n      </ng-container>      \r\n   </ng-container>\r\n</div>\r\n", styles: [".bs-property-show{cursor:pointer}.bs-property-show:hover{color:#4548dd}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { property: [{
                type: Input
            }], value: [{
                type: Input
            }] } });
function copySingleValueToClipboard(value) {
    var copyText = getNiceValueForExport(value);
    let inputField = document.createElement('input');
    inputField.setAttribute('type', 'text');
    inputField.setAttribute('id', 'clipboard_field');
    inputField.value = copyText;
    document.getElementsByTagName('body')[0].appendChild(inputField);
    inputField.select();
    inputField.setSelectionRange(0, 99999);
    document.execCommand("copy");
    var elem = document.getElementById('clipboard_field');
    elem.parentNode.removeChild(elem);
}
function getNiceValueForExport(value) {
    if (hasValidValue(value) === false) {
        return '';
    }
    if (value === true) {
        value = 'Yes';
    }
    else if (value === false) {
        value = 'No';
    }
    else if (value.Name) {
        value = value.Name;
    }
    else if (typeof value.includes === "function" && value.includes('_GHDate')) {
        let v = value.replace('_GHDate', '');
        value = stringToNiceDate(v);
    }
    else if (isStringADateFormat(value) === true) {
        value = stringToNiceDateTime(value);
    }
    else if (typeof value === 'string' &&
        (value.includes('{') || value.includes('}'))) {
        value = getOptionWithoutVariables(value);
    }
    return value;
}

class MultivalueDetailComponent {
    constructor() {
        this.disablePopup = false;
        this.unit = '';
        this.copyButton = false;
        this.multivalue = true;
        this.showHistory = false;
        this.niceBool = getNiceBool;
        this.primaryValueFromMultiValue = getFirstFromMultiValue;
    }
    checkIfArray(property) {
        if (Array.isArray) {
            if (Array.isArray(property)) {
                if (property.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            if (property instanceof Array) {
                if (property.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        return false;
    }
    ngOnInit() {
        if (!this.property) {
            this.property = new PropertyEntity();
            this.property.Type = PropertyType.Text;
        }
        this.removeMultipleValuesToAvoidAnEndlessLoop();
    }
    removeMultipleValuesToAvoidAnEndlessLoop() {
        if (this.property) {
            this.propertyClone = clonePOJO(this.property);
            this.propertyClone.MultipleValues = false;
        }
    }
    ngOnChanges() {
        this.removeMultipleValuesToAvoidAnEndlessLoop();
    }
    getNiceDate(date) {
        return getNiceDate(new Date(date));
    }
    copyToClipboard(obj) {
        let str = '';
        if (this.multivalue === true) {
            str = this.primaryValueFromMultiValue(obj);
        }
        else {
            str = obj;
        }
        //copySingleValueToClipboard(str);
    }
}
MultivalueDetailComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDetailComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MultivalueDetailComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: MultivalueDetailComponent, selector: "app-multivalue-detail", inputs: { property: "property", value: "value", disablePopup: "disablePopup", unit: "unit", copyButton: "copyButton", multivalue: "multivalue" }, usesOnChanges: true, ngImport: i0, template: "<span *ngIf=\"value\" \r\n      class=\"multivalue-detail-outer\">\r\n   <div (click)=\"copyToClipboard(value);\" \r\n        matTooltip=\"Copy to clipboard\"\r\n        class=\"copy-button\"\r\n      *ngIf=\"copyButton === true\">\r\n   </div>\r\n   <span style=\"position: relative;\" >\r\n      <span *ngIf=\"multivalue === false && !checkIfArray(value)\">\r\n         {{niceBool(value)}} {{unit}}\r\n      </span> \r\n      <span class=\"bs-multivalue-outer\" \r\n            *ngIf=\"checkIfArray(value)\">           \r\n         <span [class.multivalue]=\"value.length > 1 && multivalue === true\">\r\n            <app-show-property [property]=\"propertyClone\"\r\n                               [value]=\"primaryValueFromMultiValue(value)\">\r\n            </app-show-property>\r\n         </span>\r\n         <span *ngIf=\"disablePopup === false\">\r\n               <div class=\"bs-multivalue-label\" \r\n                    *ngIf=\"value.length > 1 && multivalue === true\">\r\n                  <div class=\"bs-multivalue-label-inner\">                    \r\n                     <ol>\r\n                        <li *ngFor=\"let i of value; let x = index\" \r\n                            style=\"padding: 5px\" \r\n                            [class.min-w]=\"x !== 0\">     \r\n                           <app-show-property [property]=\"propertyClone\"\r\n                                              [value]=\"i.Value\">\r\n                           </app-show-property>{{unit}}\r\n                        </li>\r\n                     </ol>                        \r\n                  </div>\r\n               </div>\r\n         </span>\r\n      </span>\r\n   </span> \r\n</span> \r\n<span style=\"color: rgb(211, 0, 0);\" *ngIf=\"!value\">\r\n    -\r\n</span>  ", styles: [".multivalue-detail-outer{position:relative}.bs-multivalue-outer{position:relative;white-space:nowrap}.copy-button{width:10px;height:10px;position:absolute;top:0;left:0;cursor:pointer;font-size:10px;z-index:10}.bs-multivalue-label{position:absolute;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border-radius:3px;border:1px solid #ccc;display:none;z-index:10;top:0}.bs-multivalue-label .bs-multivalue-label-inner{max-height:372px;min-width:100px;overflow:auto}.bs-multivalue-outer:hover .bs-multivalue-label{display:block}.min-w{min-width:200px}.multivalue{color:#034b86}ul,li,ol{list-style:none;margin:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: ShowPropertyComponent, selector: "app-show-property", inputs: ["property", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multivalue-detail', template: "<span *ngIf=\"value\" \r\n      class=\"multivalue-detail-outer\">\r\n   <div (click)=\"copyToClipboard(value);\" \r\n        matTooltip=\"Copy to clipboard\"\r\n        class=\"copy-button\"\r\n      *ngIf=\"copyButton === true\">\r\n   </div>\r\n   <span style=\"position: relative;\" >\r\n      <span *ngIf=\"multivalue === false && !checkIfArray(value)\">\r\n         {{niceBool(value)}} {{unit}}\r\n      </span> \r\n      <span class=\"bs-multivalue-outer\" \r\n            *ngIf=\"checkIfArray(value)\">           \r\n         <span [class.multivalue]=\"value.length > 1 && multivalue === true\">\r\n            <app-show-property [property]=\"propertyClone\"\r\n                               [value]=\"primaryValueFromMultiValue(value)\">\r\n            </app-show-property>\r\n         </span>\r\n         <span *ngIf=\"disablePopup === false\">\r\n               <div class=\"bs-multivalue-label\" \r\n                    *ngIf=\"value.length > 1 && multivalue === true\">\r\n                  <div class=\"bs-multivalue-label-inner\">                    \r\n                     <ol>\r\n                        <li *ngFor=\"let i of value; let x = index\" \r\n                            style=\"padding: 5px\" \r\n                            [class.min-w]=\"x !== 0\">     \r\n                           <app-show-property [property]=\"propertyClone\"\r\n                                              [value]=\"i.Value\">\r\n                           </app-show-property>{{unit}}\r\n                        </li>\r\n                     </ol>                        \r\n                  </div>\r\n               </div>\r\n         </span>\r\n      </span>\r\n   </span> \r\n</span> \r\n<span style=\"color: rgb(211, 0, 0);\" *ngIf=\"!value\">\r\n    -\r\n</span>  ", styles: [".multivalue-detail-outer{position:relative}.bs-multivalue-outer{position:relative;white-space:nowrap}.copy-button{width:10px;height:10px;position:absolute;top:0;left:0;cursor:pointer;font-size:10px;z-index:10}.bs-multivalue-label{position:absolute;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border-radius:3px;border:1px solid #ccc;display:none;z-index:10;top:0}.bs-multivalue-label .bs-multivalue-label-inner{max-height:372px;min-width:100px;overflow:auto}.bs-multivalue-outer:hover .bs-multivalue-label{display:block}.min-w{min-width:200px}.multivalue{color:#034b86}ul,li,ol{list-style:none;margin:0;padding:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { property: [{
                type: Input
            }], value: [{
                type: Input
            }], disablePopup: [{
                type: Input
            }], unit: [{
                type: Input
            }], copyButton: [{
                type: Input
            }], multivalue: [{
                type: Input
            }] } });

class AgDateCellRendererComponent {
    constructor() {
        this.showTime = false;
        this.multivalue = false;
    }
    agInit(params) {
        if (params && hasValidValue(params.value)) {
            this.date = params.value;
            this.showTime = params.showTime;
            if (params.multivalue) {
                this.multivalue = params.multivalue;
            }
            if (this.multivalue === true) {
                this.property = new PropertyEntity();
                this.property.MultipleValues = true;
                if (this.showTime === true) {
                    this.property.Type = PropertyType.DateTime;
                }
                else {
                    this.property.Type = PropertyType.Date;
                }
            }
        }
    }
}
AgDateCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgDateCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgDateCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgDateCellRendererComponent, selector: "app-date-ag", ngImport: i0, template: "\r\n\r\n   <ng-container *ngIf=\"multivalue === false\">\r\n      <app-show-date-time [value]=\"date\"\r\n                        [showTime]=\"showTime\">\r\n      </app-show-date-time>\r\n   </ng-container>\r\n   <ng-container *ngIf=\"multivalue === true\">\r\n      <app-multivalue-detail [value]=\"date\"                             \r\n                             [property]=\"property\">\r\n      </app-multivalue-detail>\r\n   </ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ShowDateTimeComponent, selector: "app-show-date-time", inputs: ["value", "showTime"] }, { kind: "component", type: MultivalueDetailComponent, selector: "app-multivalue-detail", inputs: ["property", "value", "disablePopup", "unit", "copyButton", "multivalue"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgDateCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-date-ag', template: "\r\n\r\n   <ng-container *ngIf=\"multivalue === false\">\r\n      <app-show-date-time [value]=\"date\"\r\n                        [showTime]=\"showTime\">\r\n      </app-show-date-time>\r\n   </ng-container>\r\n   <ng-container *ngIf=\"multivalue === true\">\r\n      <app-multivalue-detail [value]=\"date\"                             \r\n                             [property]=\"property\">\r\n      </app-multivalue-detail>\r\n   </ng-container>\r\n" }]
        }] });

// src/app/red-component/red-component.component.ts
class AgMultivalueCellRendererComponent {
    constructor() {
        this.multivalue = true;
        this.expanded = false;
    }
    agInit(params) {
        if (params && params.value) {
            this.value = params.value;
            this.property = new PropertyEntity();
            if (!params.propertyType) {
                this.property.Type = PropertyType.Text;
            }
            else {
                this.property.Type = params.propertyType;
            }
            this.object = params.data;
            this.id = params.node.id;
            this.context = params.context;
            if (params.multivalue === false) {
                this.multivalue = false;
            }
            if (params.multivalue === true) {
                this.multivalue = true;
            }
        }
    }
}
AgMultivalueCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgMultivalueCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgMultivalueCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgMultivalueCellRendererComponent, selector: "app-multivalue-detail-ag", ngImport: i0, template: "\r\n\r\n   <app-multivalue-detail [multivalue]=\"multivalue\"\r\n                        [property]=\"property\"\r\n                        [value]=\"value\">\r\n   </app-multivalue-detail>\r\n", styles: [""], dependencies: [{ kind: "component", type: MultivalueDetailComponent, selector: "app-multivalue-detail", inputs: ["property", "value", "disablePopup", "unit", "copyButton", "multivalue"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgMultivalueCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multivalue-detail-ag', template: "\r\n\r\n   <app-multivalue-detail [multivalue]=\"multivalue\"\r\n                        [property]=\"property\"\r\n                        [value]=\"value\">\r\n   </app-multivalue-detail>\r\n" }]
        }] });

// src/app/red-component/red-component.component.ts
class AgOptionsCellRendererComponent {
    agInit(params) {
        if (params && hasValidValue(params.value)) {
            this.value = params.value;
        }
    }
}
AgOptionsCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgOptionsCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgOptionsCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgOptionsCellRendererComponent, selector: "app-options-ag", ngImport: i0, template: "\r\n   <app-options [value]=\"value\"></app-options>\r\n", styles: [""], dependencies: [{ kind: "component", type: OptionsComponent, selector: "app-options", inputs: ["value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgOptionsCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-options-ag', template: "\r\n   <app-options [value]=\"value\"></app-options>\r\n" }]
        }] });

class ShowUserComponent {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    ngOnInit() {
        if (!this.value) {
            return;
        }
        /** For the case a user action is passed */
        if (this.value.Name) {
            let firstName = this.value.Name.split('.')[0];
            let lastName = this.value.Name.split('.')[1];
            firstName = this.uppercaseString(firstName);
            lastName = this.uppercaseString(lastName);
            this.value.Name = firstName + ' ' + lastName;
        }
        //this.loadUser();
    }
    async loadUser() {
        if (this.value && this.value.Name != "System"
            && this.value.Name != "System ") {
            const newUser = await this.userRepository.getById(this.value.Id, true, null);
            if (newUser) {
                this.value = newUser;
            }
        }
    }
    uppercaseString(valueToUppercase) {
        if (valueToUppercase) {
            valueToUppercase = valueToUppercase.charAt(0).toUpperCase() + valueToUppercase.slice(1);
            return valueToUppercase;
        }
        else {
            return '';
        }
    }
}
ShowUserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowUserComponent, deps: [{ token: i1$1.UserRepository }], target: i0.ɵɵFactoryTarget.Component });
ShowUserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: ShowUserComponent, selector: "app-show-user", inputs: { value: "value" }, ngImport: i0, template: "<div class=\"bs-user-info-wrapper\">\r\n   <ng-container *ngIf=\"value && value.Name\">\r\n      {{value.Name}}\r\n   </ng-container>\r\n   <ng-container *ngIf=\"value && value.FirstName\">\r\n      <div class=\"bs-user-name-xxx\">{{value.FirstName}} {{value.LastName}}</div>      \r\n      <!-- <div class=\"clear-both\"></div> -->\r\n   </ng-container>\r\n</div>", styles: [".bs-user-info-details{display:none;position:absolute;background-color:#fff;border-radius:3px;border:1px solid #ccc;padding:10px;color:#000}.bs-user-info-wrapper{position:relative}.bs-user-info-wrapper:hover .bs-user-info-details{display:block}.bs-user-name{float:left;margin-left:10px;margin-top:10px}.bs-user-picture{float:left}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: ShowUserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-show-user', template: "<div class=\"bs-user-info-wrapper\">\r\n   <ng-container *ngIf=\"value && value.Name\">\r\n      {{value.Name}}\r\n   </ng-container>\r\n   <ng-container *ngIf=\"value && value.FirstName\">\r\n      <div class=\"bs-user-name-xxx\">{{value.FirstName}} {{value.LastName}}</div>      \r\n      <!-- <div class=\"clear-both\"></div> -->\r\n   </ng-container>\r\n</div>", styles: [".bs-user-info-details{display:none;position:absolute;background-color:#fff;border-radius:3px;border:1px solid #ccc;padding:10px;color:#000}.bs-user-info-wrapper{position:relative}.bs-user-info-wrapper:hover .bs-user-info-details{display:block}.bs-user-name{float:left;margin-left:10px;margin-top:10px}.bs-user-picture{float:left}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.UserRepository }]; }, propDecorators: { value: [{
                type: Input
            }] } });

// src/app/red-component/red-component.component.ts
class AgUserCellRendererComponent {
    agInit(params) {
        if (params && params.value) {
            this.user = params.value;
        }
    }
}
AgUserCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgUserCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgUserCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgUserCellRendererComponent, selector: "app-user-ag", ngImport: i0, template: "\r\n   <app-show-user [value]=\"user\"></app-show-user>\r\n", styles: [""], dependencies: [{ kind: "component", type: ShowUserComponent, selector: "app-show-user", inputs: ["value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgUserCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-user-ag', template: "\r\n   <app-show-user [value]=\"user\"></app-show-user>\r\n" }]
        }] });

// src/app/red-component/red-component.component.ts
class AgUsersCellRendererComponent {
    agInit(params) {
        if (params && params.value) {
            this.users = params.value;
            if (this.users.length > 1) {
                let a = 8;
            }
        }
    }
}
AgUsersCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgUsersCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgUsersCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgUsersCellRendererComponent, selector: "app-users-ag", ngImport: i0, template: "\r\n<div class=\"bs-horizontal-user-list\">\r\n   <div *ngFor=\"let user of users\"\r\n        style=\"margin-left: 10px;\">\r\n      <app-show-user [value]=\"user\"></app-show-user>\r\n   </div>\r\n   <div class=\"clear-both\"></div>\r\n</div>\r\n", styles: [".bs-horizontal-user-list{width:10000px}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: ShowUserComponent, selector: "app-show-user", inputs: ["value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgUsersCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-users-ag', template: "\r\n<div class=\"bs-horizontal-user-list\">\r\n   <div *ngFor=\"let user of users\"\r\n        style=\"margin-left: 10px;\">\r\n      <app-show-user [value]=\"user\"></app-show-user>\r\n   </div>\r\n   <div class=\"clear-both\"></div>\r\n</div>\r\n", styles: [".bs-horizontal-user-list{width:10000px}\n"] }]
        }] });

class AgYesNoCellRendererComponent {
    agInit(params) {
        if (params && hasValidValue(params.value)) {
            this.yesNo = params.value;
        }
    }
}
AgYesNoCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgYesNoCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgYesNoCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgYesNoCellRendererComponent, selector: "app-yesno-ag", ngImport: i0, template: "<app-yes-no [value]=\"yesNo\"></app-yes-no>\r\n", styles: [""], dependencies: [{ kind: "component", type: YesNoComponent, selector: "app-yes-no", inputs: ["value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgYesNoCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-yesno-ag', template: "<app-yes-no [value]=\"yesNo\"></app-yes-no>\r\n" }]
        }] });

class MultivalueDetailAgGridComponent {
    constructor() {
        this.multivalue = true;
    }
    agInit(params) {
        if (params) {
            if (params.value) {
                if (params.value) {
                    this.value = params.value;
                }
                if (params.multivalue === false) {
                    this.multivalue = false;
                }
                if (params.multivalue === true) {
                    this.multivalue = true;
                }
            }
        }
    }
}
MultivalueDetailAgGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDetailAgGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MultivalueDetailAgGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: MultivalueDetailAgGridComponent, selector: "app-multivalue-detail-ag", ngImport: i0, template: "<app-multivalue-detail [multivalue]=\"multivalue\"\r\n                       [value]=\"value\">\r\n</app-multivalue-detail>", dependencies: [{ kind: "component", type: MultivalueDetailComponent, selector: "app-multivalue-detail", inputs: ["property", "value", "disablePopup", "unit", "copyButton", "multivalue"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: MultivalueDetailAgGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-multivalue-detail-ag', template: "<app-multivalue-detail [multivalue]=\"multivalue\"\r\n                       [value]=\"value\">\r\n</app-multivalue-detail>" }]
        }] });

class AgBoolFilterComponent {
    constructor() {
        this.hasValidValue = hasValidValue;
    }
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
    }
    isFilterActive() {
        if (hasValidValue(this.yesNoValue)) {
            return true;
        }
        return false;
    }
    doesFilterPass(params) {
        return true;
    }
    getModel() {
        if (this.yesNoValue === true) {
            return 'true';
        }
        else if (this.yesNoValue === false) {
            return 'false';
        }
        else {
            return null;
        }
    }
    setModel(model) {
        if (model === 'true') {
            this.yesNoValue = true;
        }
        else if (model === 'false') {
            this.yesNoValue = false;
        }
        else {
            this.yesNoValue = null;
        }
    }
    onNewRowsLoaded() {
    }
    onAnyFilterChanged() {
        this.params.filterChangedCallback();
    }
    getFrameworkComponentInstance() {
    }
    getModelAsString(model) {
        return getNiceBool(model);
    }
    afterGuiAttached(params) {
    }
    toggle(checkbox, event) {
        event.preventDefault();
        if (checkbox.checked === false && checkbox.indeterminate === true) {
            checkbox.checked = false;
            checkbox.indeterminate = false;
            this.yesNoValue = false;
        }
        else if (checkbox.checked === true && checkbox.indeterminate === false) {
            checkbox.checked = false;
            checkbox.indeterminate = true;
            this.yesNoValue = null;
        }
        else if (checkbox.checked === false && checkbox.indeterminate === false) {
            checkbox.checked = true;
            checkbox.indeterminate = false;
            this.yesNoValue = true;
        }
        this.params.filterChangedCallback();
    }
}
AgBoolFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgBoolFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgBoolFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgBoolFilterComponent, selector: "app-ag-bool-filter", ngImport: i0, template: "<div class=\"bs-custom-filter-outer\">\r\n   <mat-checkbox [(ngModel)]=\"yesNoValue\"\r\n                 #forme\r\n                 [indeterminate]=\"!hasValidValue(yesNoValue) ? true : false\"\r\n                 (click)=\"toggle(forme, $event)\" \r\n                 color=\"primary\">\r\n      Yes/No Filter\r\n   </mat-checkbox>  \r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgBoolFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ag-bool-filter', template: "<div class=\"bs-custom-filter-outer\">\r\n   <mat-checkbox [(ngModel)]=\"yesNoValue\"\r\n                 #forme\r\n                 [indeterminate]=\"!hasValidValue(yesNoValue) ? true : false\"\r\n                 (click)=\"toggle(forme, $event)\" \r\n                 color=\"primary\">\r\n      Yes/No Filter\r\n   </mat-checkbox>  \r\n</div>" }]
        }], ctorParameters: function () { return []; } });

class AgDateFilterComponent {
    constructor() {
        this.selectedOptions = [];
    }
    agInit(params) {
        this.params = params;
        this.refreshOptionSelection();
        this.valueGetter = params.valueGetter;
    }
    refreshOptionSelection() {
        if (this.selectOptions) {
            this.selectOptions.forEach(option => {
                this.selectedOptions.push(false);
            });
        }
    }
    isFilterActive() {
        return this.selectedOptions.includes(true);
    }
    doesFilterPass(params) {
        return true;
    }
    getModel() {
        let resultText = '';
        if (this.selectOptions) {
            let cnt = 0;
            this.selectOptions.forEach(option => {
                if (this.selectedOptions[cnt] === true) {
                    resultText += cnt;
                }
                cnt++;
            });
        }
        return resultText;
    }
    setModel(model) {
    }
    onNewRowsLoaded() {
    }
    onAnyFilterChanged() {
        this.params.filterChangedCallback();
    }
    getFrameworkComponentInstance() {
    }
    getModelAsString(model) {
        return this.getModel();
    }
    afterGuiAttached(params) {
    }
}
AgDateFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgDateFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgDateFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgDateFilterComponent, selector: "app-ag-date-filter", ngImport: i0, template: "Implementation missing", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgDateFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ag-date-filter', template: "Implementation missing" }]
        }], ctorParameters: function () { return []; } });

class AgNoFilterComponent {
    isFilterActive() {
        return false;
    }
    doesFilterPass(params) {
        return false;
    }
    getModel() {
    }
    setModel(model) {
    }
    onNewRowsLoaded() {
    }
    onAnyFilterChanged() {
    }
    getFrameworkComponentInstance() {
    }
    getModelAsString(model) {
        return '';
    }
    agInit(params) {
    }
    afterGuiAttached(params) {
    }
}
AgNoFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgNoFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgNoFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgNoFilterComponent, selector: "app-ag-no-filter", ngImport: i0, template: "Cannot filter here", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgNoFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ag-no-filter', template: "Cannot filter here" }]
        }] });

class SetFilterComponent {
    constructor(changeDet) {
        this.changeDet = changeDet;
        this.selectionChanged = new EventEmitter();
        this.getOptionWithoutVariables = getOptionWithoutVariables;
        this.selectedOptions = [];
        this.propagateChange = _ => { };
    }
    ngOnInit() {
    }
    publish() {
        let result = '';
        let cnt = 0;
        for (const num of this.selectedOptions) {
            if (num === true) {
                result += cnt + ' ';
            }
            cnt++;
        }
        this.propagateChange(result);
    }
    change() {
        this.changeDet.detectChanges();
        this.publish();
        this.selectionChanged.emit();
    }
    writeValue(inputValue) {
        this.selectedOptions = [];
        if (this.optionLabels) {
            this.optionLabels.forEach(option => {
                this.selectedOptions.push(false);
            });
        }
        if (inputValue) {
            let numbers = inputValue.split(' ');
            numbers.forEach(num => {
                let realNum = parseInt(num);
                this.optionLabels[num] = true;
            });
        }
    }
    validate(formControl) {
        return null;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
}
SetFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: SetFilterComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SetFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: SetFilterComponent, selector: "app-set-filter", inputs: { optionLabels: "optionLabels" }, outputs: { selectionChanged: "selectionChanged" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SetFilterComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SetFilterComponent),
            multi: true
        }
    ], ngImport: i0, template: "<ng-container *ngFor=\"let option of optionLabels; let i = index\">\r\n   <mat-checkbox [(ngModel)]=\"selectedOptions[i]\"\r\n                 (change)=\"change()\"\r\n                 color=\"primary\">\r\n       {{getOptionWithoutVariables(option.Value)}}\r\n   </mat-checkbox> \r\n   <br>   \r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: SetFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-set-filter', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SetFilterComponent),
                            multi: true,
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => SetFilterComponent),
                            multi: true
                        }
                    ], template: "<ng-container *ngFor=\"let option of optionLabels; let i = index\">\r\n   <mat-checkbox [(ngModel)]=\"selectedOptions[i]\"\r\n                 (change)=\"change()\"\r\n                 color=\"primary\">\r\n       {{getOptionWithoutVariables(option.Value)}}\r\n   </mat-checkbox> \r\n   <br>   \r\n</ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { optionLabels: [{
                type: Input
            }], selectionChanged: [{
                type: Output
            }] } });

class AgSetFilterComponent {
    constructor() { }
    agInit(params) {
        this.params = params;
        this.selectOptions = params.options;
        this.refreshOptionSelection();
        this.valueGetter = params.valueGetter;
    }
    refreshOptionSelection() {
    }
    isFilterActive() {
        if (!this.selection) {
            return false;
        }
        return this.selection.length > 0;
    }
    doesFilterPass(params) {
        return true;
    }
    getModel() {
        return this.selection;
    }
    setModel(model) {
    }
    onNewRowsLoaded() {
    }
    onAnyFilterChanged() {
        this.params.filterChangedCallback();
    }
    getFrameworkComponentInstance() {
    }
    getModelAsString(model) {
        return this.getModel();
    }
    afterGuiAttached(params) {
    }
}
AgSetFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgSetFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgSetFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgSetFilterComponent, selector: "app-ag-set-filter", ngImport: i0, template: "<div class=\"bs-custom-filter-outer\">\r\n   <app-set-filter [optionLabels]=\"selectOptions\"\r\n                   (selectionChanged)=\"onAnyFilterChanged()\"\r\n                   [(ngModel)]=\"selection\">\r\n   </app-set-filter>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SetFilterComponent, selector: "app-set-filter", inputs: ["optionLabels"], outputs: ["selectionChanged"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgSetFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ag-set-filter', template: "<div class=\"bs-custom-filter-outer\">\r\n   <app-set-filter [optionLabels]=\"selectOptions\"\r\n                   (selectionChanged)=\"onAnyFilterChanged()\"\r\n                   [(ngModel)]=\"selection\">\r\n   </app-set-filter>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; } });

class AgTextFilterComponent {
    constructor() { }
    agInit(params) {
        this.params = params;
        this.hasIndex = params.hasIndex;
        this.isNumeric = params.isNumeric;
        this.valueGetter = params.valueGetter;
    }
    isFilterActive() {
        return this.filterText != null && this.filterText !== '';
    }
    doesFilterPass(params) {
        return true;
    }
    getModel() {
        return this.filterText;
    }
    setModel(model) {
        this.filterText = model;
    }
    onNewRowsLoaded() {
    }
    onAnyFilterChanged() {
        this.params.filterChangedCallback();
    }
    getFrameworkComponentInstance() {
    }
    getModelAsString(model) {
        return this.filterText;
    }
    afterGuiAttached(params) {
    }
}
AgTextFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgTextFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AgTextFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AgTextFilterComponent, selector: "app-ag-text-filter", ngImport: i0, template: "<div class=\"bs-custom-filter-outer\">\r\n   <app-bs-textfield [placeholder]=\"isNumeric ? 'Number equals' : 'Contains text'\"\r\n                     (valueChanged)=\"onAnyFilterChanged()\"\r\n                     *ngIf=\"hasIndex === true\"\r\n                     [(ngModel)]=\"filterText\">\r\n   </app-bs-textfield>\r\n   <div *ngIf=\"!hasIndex && !isNumeric\"\r\n         matTooltip=\"This property was not included in the search index by your admin. Please change the settings of the property, if you want to filter here.\"\r\n        class=\"bs-pending-indicator\">\r\n      Not set as 'searchable'\r\n   </div>\r\n</div>", styles: [""], dependencies: [{ kind: "component", type: i2.BSTextfieldComponent, selector: "app-bs-textfield", inputs: ["iconClass", "invalid", "inputType", "placeholder", "errorStateMatcher", "showPlaceholder"], outputs: ["valueChanged"] }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AgTextFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-ag-text-filter', template: "<div class=\"bs-custom-filter-outer\">\r\n   <app-bs-textfield [placeholder]=\"isNumeric ? 'Number equals' : 'Contains text'\"\r\n                     (valueChanged)=\"onAnyFilterChanged()\"\r\n                     *ngIf=\"hasIndex === true\"\r\n                     [(ngModel)]=\"filterText\">\r\n   </app-bs-textfield>\r\n   <div *ngIf=\"!hasIndex && !isNumeric\"\r\n         matTooltip=\"This property was not included in the search index by your admin. Please change the settings of the property, if you want to filter here.\"\r\n        class=\"bs-pending-indicator\">\r\n      Not set as 'searchable'\r\n   </div>\r\n</div>" }]
        }], ctorParameters: function () { return []; } });

class DatahiveNgxStructureModule {
}
DatahiveNgxStructureModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DatahiveNgxStructureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DatahiveNgxStructureModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.1", ngImport: i0, type: DatahiveNgxStructureModule, declarations: [ComponentDefinitionControlsComponent,
        PropertyControlMultiValueComponent,
        MultivalueComponent,
        PropertyControlComponent,
        MultivalueDialogComponent,
        ShowDateTimeComponent,
        OptionsComponent,
        ShowPropertyComponent,
        ShowUserComponent,
        YesNoComponent,
        AgCalcPropertyCellRendererComponent,
        AgCounryFlagsCellRendererComponent,
        AgDateCellRendererComponent,
        AgMultivalueCellRendererComponent,
        MultivalueDetailComponent,
        AgOptionsCellRendererComponent,
        AgUserCellRendererComponent,
        AgUsersCellRendererComponent,
        AgYesNoCellRendererComponent,
        MultivalueDetailAgGridComponent,
        AgBoolFilterComponent,
        AgDateFilterComponent,
        AgNoFilterComponent,
        AgSetFilterComponent,
        AgTextFilterComponent,
        SetFilterComponent], imports: [DatahiveNgxUiModule,
        DataHiveNgxGraphModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        /** Material  */
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatCardModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule], exports: [ComponentDefinitionControlsComponent,
        PropertyControlMultiValueComponent,
        MultivalueComponent,
        MultivalueDetailComponent,
        PropertyControlComponent,
        MultivalueDialogComponent,
        ShowDateTimeComponent,
        OptionsComponent,
        ShowPropertyComponent,
        ShowUserComponent,
        YesNoComponent,
        AgCalcPropertyCellRendererComponent,
        AgCounryFlagsCellRendererComponent,
        AgDateCellRendererComponent,
        AgMultivalueCellRendererComponent,
        AgOptionsCellRendererComponent,
        AgUserCellRendererComponent,
        AgUsersCellRendererComponent,
        AgYesNoCellRendererComponent,
        MultivalueDetailAgGridComponent,
        AgBoolFilterComponent,
        AgDateFilterComponent,
        AgNoFilterComponent,
        AgSetFilterComponent,
        AgTextFilterComponent,
        SetFilterComponent] });
DatahiveNgxStructureModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DatahiveNgxStructureModule, imports: [DatahiveNgxUiModule,
        DataHiveNgxGraphModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        /** Material  */
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatCardModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DatahiveNgxStructureModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ComponentDefinitionControlsComponent,
                        PropertyControlMultiValueComponent,
                        MultivalueComponent,
                        PropertyControlComponent,
                        MultivalueDialogComponent,
                        ShowDateTimeComponent,
                        OptionsComponent,
                        ShowPropertyComponent,
                        ShowUserComponent,
                        YesNoComponent,
                        AgCalcPropertyCellRendererComponent,
                        AgCounryFlagsCellRendererComponent,
                        AgDateCellRendererComponent,
                        AgMultivalueCellRendererComponent,
                        MultivalueDetailComponent,
                        AgOptionsCellRendererComponent,
                        AgUserCellRendererComponent,
                        AgUsersCellRendererComponent,
                        AgYesNoCellRendererComponent,
                        MultivalueDetailAgGridComponent,
                        AgBoolFilterComponent,
                        AgDateFilterComponent,
                        AgNoFilterComponent,
                        AgSetFilterComponent,
                        AgTextFilterComponent,
                        SetFilterComponent,
                    ],
                    imports: [
                        DatahiveNgxUiModule,
                        DataHiveNgxGraphModule,
                        ReactiveFormsModule,
                        FormsModule,
                        CommonModule,
                        /** Material  */
                        MatFormFieldModule,
                        MatInputModule,
                        MatDialogModule,
                        MatCardModule,
                        MatSlideToggleModule,
                        MatSliderModule,
                        MatCheckboxModule,
                        MatRadioModule,
                        MatTooltipModule,
                        MatDatepickerModule,
                        MatOptionModule,
                        MatSelectModule,
                        MatButtonModule,
                    ],
                    exports: [
                        ComponentDefinitionControlsComponent,
                        PropertyControlMultiValueComponent,
                        MultivalueComponent,
                        MultivalueDetailComponent,
                        PropertyControlComponent,
                        MultivalueDialogComponent,
                        ShowDateTimeComponent,
                        OptionsComponent,
                        ShowPropertyComponent,
                        ShowUserComponent,
                        YesNoComponent,
                        AgCalcPropertyCellRendererComponent,
                        AgCounryFlagsCellRendererComponent,
                        AgDateCellRendererComponent,
                        AgMultivalueCellRendererComponent,
                        AgOptionsCellRendererComponent,
                        AgUserCellRendererComponent,
                        AgUsersCellRendererComponent,
                        AgYesNoCellRendererComponent,
                        MultivalueDetailAgGridComponent,
                        AgBoolFilterComponent,
                        AgDateFilterComponent,
                        AgNoFilterComponent,
                        AgSetFilterComponent,
                        AgTextFilterComponent,
                        SetFilterComponent,
                    ]
                }]
        }] });

class ComponentDefinitionEntity extends BaseEntity {
    constructor() {
        super();
    }
    getPropertyByIdFromComponentDefinition(propertyId, compDef) {
        if (!compDef.Segments) {
            return null;
        }
        for (const segment of compDef.Segments) {
            if (segment.Properties && segment.Properties.length > 0) {
                for (const property of segment.Properties) {
                    if (property.Id === propertyId) {
                        return property;
                    }
                }
            }
        }
        return null;
    }
}
function getPropertiesOfComponentDefinition(compDef) {
    let properties = [];
    if (compDef) {
        for (const segment of compDef.Segments) {
            if (segment) {
                for (const property of segment.Properties) {
                    properties.push(property);
                }
            }
        }
    }
    return properties;
}

class ComponentSegmentEntity {
    constructor() {
        this.Properties = [];
    }
}

class ShowCondition {
}

function getColDefinitionsForComponentDefinition(componentDefinition, index = null, basicInformationPropertyName = 'BasicInformation', propertyPrefix = '') {
    const targetChildGroup = [];
    if (!componentDefinition.Segments) {
        return null;
    }
    componentDefinition.Segments.forEach(segment => {
        if (propertyPrefix != '') {
            propertyPrefix = propertyPrefix + ' ';
        }
        const colDef = {};
        colDef.headerName = segment.Name;
        colDef.id = '0000',
            colDef.children = [];
        if (segment.Properties) {
            segment.Properties.forEach(property => {
                const def = {
                    headerName: propertyPrefix + property.Name + ' ' + (property.Type === PropertyType.Calculated ? 'f(x)' : ''),
                    headerTooltip: property.Name + ' ' + (property.Description ? property.Description : ''),
                    field: index || index === 0 ? 'Components.' + componentDefinition.EntityId + '.' + index + '.' + property.Id : basicInformationPropertyName + '.' + property.Id,
                };
                def.filter = 'agNoFilter';
                if (property.Type === PropertyType.DateTime) {
                    def.cellRendererFramework = AgDateCellRendererComponent;
                    def.filter = 'agDateFilter';
                    def.cellRendererParams = { showTime: true, multivalue: property.MultipleValues };
                }
                if (property.Type === PropertyType.Date) {
                    def.cellRendererFramework = AgDateCellRendererComponent;
                    def.filter = 'agDateFilter';
                    def.cellRendererParams = { showTime: false, multivalue: property.MultipleValues };
                }
                if (property.Type === PropertyType.YesNo) {
                    def.cellRendererFramework = AgYesNoCellRendererComponent;
                    def.filter = 'agBoolFilter';
                }
                if (property.Type === PropertyType.User) {
                    def.cellRendererFramework = AgUserCellRendererComponent;
                }
                if (property.Type === PropertyType.Select) {
                    def.cellRendererFramework = AgOptionsCellRendererComponent;
                    def.filter = 'agSetFilter';
                    def.filterParams = { options: property.Options };
                }
                if ((property.IncludeInQuickSearch === true && property.Type === PropertyType.Text) || property.Type === PropertyType.Number) {
                    def.filterParams = { hasIndex: true, isNumeric: true };
                    def.filter = 'agTextFilter';
                }
                if (property.MultipleValues === true) {
                    def.cellRendererFramework = AgMultivalueCellRendererComponent,
                        def.cellRendererParams = { propertyType: property.Type };
                }
                if (property.Type === PropertyType.Text && property.IncludeInQuickSearch === false) {
                    def.suppressMenu = true;
                }
                else {
                    def.suppressMenu = false;
                }
                if (property.Type === PropertyType.Calculated) {
                    def.cellRendererFramework = AgCalcPropertyCellRendererComponent;
                    def.suppressMenu = true;
                    def.sortable = false;
                }
                colDef.children.push(def);
            });
        }
        targetChildGroup.push(colDef);
    });
    return targetChildGroup;
}
function removeGeneralColumnDefinition(gridOptions) {
    /** If switching between suppliers and customer liste, remove general column (0000) if existing. */
    gridOptions.columnDefs = gridOptions.columnDefs.filter(column => column.id !== '0000');
}

class OptionModel {
}

/**
 * Generated bundle index. Do not edit.
 */

export { AgBoolFilterComponent, AgCalcPropertyCellRendererComponent, AgCounryFlagsCellRendererComponent, AgDateCellRendererComponent, AgDateFilterComponent, AgMultivalueCellRendererComponent, AgNoFilterComponent, AgOptionsCellRendererComponent, AgSetFilterComponent, AgTextFilterComponent, AgUserCellRendererComponent, AgUsersCellRendererComponent, AgYesNoCellRendererComponent, ComponentDefinitionControlsComponent, ComponentDefinitionEntity, ComponentSegmentEntity, ConditionType, ControlType, DatahiveNgxStructureModule, InputDataType, InputType, Multivalue, MultivalueComponent, MultivalueDetailAgGridComponent, MultivalueDetailComponent, MultivalueDialogComponent, OptionModel, OptionsComponent, PropertyControlComponent, PropertyControlMultiValueComponent, PropertyEntity, PropertyType, SetFilterComponent, ShowCondition, ShowDateTimeComponent, ShowPropertyComponent, ShowUserComponent, ValidationFunctions, YesNoComponent, copyProperty, copySingleValueToClipboard, getColDefinitionsForComponentDefinition, getFirstFromMultiValue, getMultiValueForm, getMultivalueAsString, getNiceValueForExport, getOptionWithoutVariables, getPropertiesOfComponentDefinition, getSecondaryFromMultiValueIfExistsOtherWiseFirst, isMultivalueCheckboxEnabled, multivalueDoubleFactory, multivalueFactory, removeGeneralColumnDefinition };
